import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A valid DateTime, transported as a iso8601 string */
  DateTime: any;
  /** Represents non-fractional signed whole numeric values. Since the value may exceed the size of a 32-bit integer, it's encoded as a string. */
  BigInt: any;
  /** An lot ID */
  LotID: any;
  /** A valid JSON object */
  JSON: any;
  /** A secure, escaped string! */
  SecureString: any;
};

export type Query = {
  __typename?: 'Query';
  alerts?: Maybe<Array<Alert>>;
  applicationSettings?: Maybe<ApplicationSetting>;
  auctions: Array<Auction>;
  auctionsTradingTimeShifts?: Maybe<AuctionTradingTimeShiftPaginatedList>;
  averagePrice?: Maybe<Array<AveragePrice>>;
  bidConditions: Array<BidCondition>;
  bidScore?: Maybe<Scalars['Float']>;
  boundaryLots?: Maybe<LotPaginatedList>;
  carPageScreenshot?: Maybe<Scalars['String']>;
  carPageTemplate?: Maybe<Scalars['String']>;
  countries: Array<Country>;
  countryBlocked: Scalars['Boolean'];
  currentUser?: Maybe<CurrentUser>;
  exchangeRate: ExchangeRate;
  lot?: Maybe<Lot>;
  lots?: Maybe<LotPaginatedList>;
  lotsByKeys?: Maybe<Array<Lot>>;
  lotsByOriginalIds?: Maybe<Array<Lot>>;
  lotsInspected?: Maybe<Array<LotInspection>>;
  lotsViewsCounts?: Maybe<Array<LotViewsCount>>;
  lotViewsCount?: Maybe<LotViewsCount>;
  maxBidAmount?: Maybe<Scalars['Int']>;
  minBidCommission?: Maybe<Scalars['Int']>;
  negotiationLotLookup?: Maybe<Array<Lot>>;
  negotiationLots?: Maybe<LotPaginatedList>;
  negotiationLotsCount?: Maybe<Scalars['Int']>;
  userRequests?: Maybe<UserRequestUnionPaginatedList>;
  vincheckerInfo?: Maybe<Array<VincheckerInfo>>;
  weightedHarmonicMean?: Maybe<Scalars['Float']>;
};


export type QueryAlertsArgs = {
  auctionId?: Maybe<Scalars['ID']>;
  catalogCompanyTitle?: Maybe<Scalars['String']>;
  catalogFrameCode?: Maybe<Scalars['String']>;
  catalogModelTitle?: Maybe<Scalars['String']>;
  countryIso?: Maybe<Scalars['String']>;
  isSanctioned?: Maybe<Scalars['Boolean']>;
  lotCode?: Maybe<Scalars['Int']>;
  target?: Maybe<AlertTargetEnum>;
};


export type QueryAuctionsArgs = {
  withUnassignedCartrackAuction?: Maybe<Scalars['Boolean']>;
};


export type QueryAuctionsTradingTimeShiftsArgs = {
  filter?: Maybe<TradingTimeShiftsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<TradingTimeShiftsSort>;
};


export type QueryAveragePriceArgs = {
  companyEn: Scalars['String'];
  modelEn: Scalars['String'];
  modelTypeEn?: Maybe<Scalars['String']>;
  subgroup: Scalars['String'];
};


export type QueryBidScoreArgs = {
  amount: Scalars['Int'];
  companyEn: Scalars['String'];
  mileage: Scalars['Int'];
  modelEn: Scalars['String'];
  modelTypeEn: Scalars['String'];
  ratingEn: Scalars['String'];
  year: Scalars['Int'];
};


export type QueryBoundaryLotsArgs = {
  filter?: Maybe<BoundaryLotsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryCarPageScreenshotArgs = {
  lotId: Scalars['String'];
  lotSource?: Maybe<LotSource>;
  lotType?: Maybe<LotTypeEnum>;
};


export type QueryCarPageTemplateArgs = {
  lotId: Scalars['String'];
  lotSource?: Maybe<LotSource>;
  lotType?: Maybe<LotTypeEnum>;
};


export type QueryExchangeRateArgs = {
  date?: Maybe<Scalars['DateTime']>;
  iso: CurrencyEnum;
};


export type QueryLotArgs = {
  id: Scalars['LotID'];
  lotSource: LotSource;
  siteDomain?: Maybe<Scalars['String']>;
  subgroup: LotTypeEnum;
};


export type QueryLotsArgs = {
  filter?: Maybe<LotsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<LotsSort>;
};


export type QueryLotsByKeysArgs = {
  lotKeys?: Maybe<Array<CodeDateAuctionNameInput>>;
};


export type QueryLotsByOriginalIdsArgs = {
  lotSource: LotSource;
  lotType: LotTypeEnum;
  originalIds: Array<Scalars['LotID']>;
};


export type QueryLotsInspectedArgs = {
  lots: Array<LotInspectionInput>;
};


export type QueryLotsViewsCountsArgs = {
  lotIds: Array<Scalars['String']>;
  lotSource: LotSource;
  lotType: LotTypeEnum;
};


export type QueryLotViewsCountArgs = {
  lotId: Scalars['LotID'];
  lotSource: LotSource;
  lotType: LotTypeEnum;
};


export type QueryMaxBidAmountArgs = {
  lotType: LotTypeEnum;
};


export type QueryMinBidCommissionArgs = {
  lotType: LotTypeEnum;
};


export type QueryNegotiationLotLookupArgs = {
  lotId: Scalars['LotID'];
  lotSource: LotSource;
};


export type QueryNegotiationLotsArgs = {
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryUserRequestsArgs = {
  filter?: Maybe<UserRequestsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryWeightedHarmonicMeanArgs = {
  companyEn: Scalars['String'];
  mileage: Scalars['Int'];
  modelEn: Scalars['String'];
  modelTypeEn: Scalars['String'];
  noOfDays?: Maybe<Scalars['Int']>;
  ratingEn: Scalars['String'];
  year: Scalars['Int'];
};

export enum AlertTargetEnum {
  Bidding = 'bidding',
  LotPage = 'lot_page',
  LotPageOneprice = 'lot_page_oneprice',
  MainPage = 'main_page',
  Profile = 'profile'
}

export type Alert = {
  __typename?: 'Alert';
  catalogCompany?: Maybe<CatalogCompany>;
  catalogCompanyId?: Maybe<Scalars['ID']>;
  catalogFrame?: Maybe<CatalogFrame>;
  catalogFrameId?: Maybe<Scalars['ID']>;
  catalogModel?: Maybe<CatalogModel>;
  catalogModelId?: Maybe<Scalars['ID']>;
  contentEn?: Maybe<Scalars['String']>;
  contentRu?: Maybe<Scalars['String']>;
  countryIso?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  isOnetime?: Maybe<Scalars['Boolean']>;
  isSanctioned?: Maybe<Scalars['Boolean']>;
  style?: Maybe<AlertStyleEnum>;
  target?: Maybe<AlertTargetEnum>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CatalogCompany = {
  __typename?: 'CatalogCompany';
  id?: Maybe<Scalars['ID']>;
  models?: Maybe<Array<CatalogModel>>;
  title?: Maybe<Scalars['String']>;
};

export type CatalogModel = {
  __typename?: 'CatalogModel';
  company?: Maybe<CatalogCompany>;
  frames?: Maybe<Array<CatalogFrame>>;
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
};

export type CatalogFrame = {
  __typename?: 'CatalogFrame';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  model?: Maybe<CatalogModel>;
};

export enum AlertStyleEnum {
  Error = 'error',
  Info = 'info',
  Success = 'success',
  Warning = 'warning'
}

export type ApplicationSetting = {
  __typename?: 'ApplicationSetting';
  aiTranslationGenerationEnabled?: Maybe<Scalars['Boolean']>;
  greenCornerContactFormManagerId?: Maybe<Scalars['Int']>;
  greenCornerContactFormNotificationEmail?: Maybe<Scalars['String']>;
};

export type Auction = {
  __typename?: 'Auction';
  auctionAliases?: Maybe<Array<Auction>>;
  auctionDescription?: Maybe<AuctionDescription>;
  auctionSheetZones?: Maybe<Array<AuctionSheetZone>>;
  cartrackAuctionId?: Maybe<Scalars['ID']>;
  currentTradingTimeShifts?: Maybe<Array<AuctionTradingTimeShift>>;
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
};

export type AuctionDescription = {
  __typename?: 'AuctionDescription';
  aiTranslationEnabled?: Maybe<Scalars['Boolean']>;
  aiTranslationPrompt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type AuctionSheetZone = {
  __typename?: 'AuctionSheetZone';
  code?: Maybe<Scalars['String']>;
  h?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  w?: Maybe<Scalars['Float']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  zoneType?: Maybe<AuctionSheetZoneTypeEnum>;
};

export enum AuctionSheetZoneTypeEnum {
  TranslatableInfo = 'translatable_info',
  Vin = 'vin'
}

export type AuctionTradingTimeShift = {
  __typename?: 'AuctionTradingTimeShift';
  auctionDate?: Maybe<Scalars['String']>;
  auctionId?: Maybe<Scalars['ID']>;
  codeFrom?: Maybe<Scalars['BigInt']>;
  codeTo?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creatorId?: Maybe<Scalars['ID']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  shiftInSeconds?: Maybe<Scalars['Int']>;
  speedUp?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TradingTimeShiftsFilter = {
  auctionTradingTimeShiftAuctionDate?: Maybe<AuctionTradingTimeShiftAuctionDateFilter>;
  auctionTradingTimeShiftAuctionIds?: Maybe<AuctionTradingTimeShiftAuctionIdsFilter>;
};

export type AuctionTradingTimeShiftAuctionDateFilter = {
  gte?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
};

export type AuctionTradingTimeShiftAuctionIdsFilter = {
  eq?: Maybe<Array<Scalars['ID']>>;
};

export type TradingTimeShiftsSort = {
  auctionTradingTimeShiftAuctionDate?: Maybe<AuctionTradingTimeShiftAuctionDateSort>;
};

export type AuctionTradingTimeShiftAuctionDateSort = {
  direction?: Maybe<Scalars['String']>;
};

export type AuctionTradingTimeShiftPaginatedList = {
  __typename?: 'AuctionTradingTimeShiftPaginatedList';
  nodes: Array<AuctionTradingTimeShift>;
  total: Scalars['Int'];
};

export type AveragePrice = {
  __typename?: 'AveragePrice';
  avg?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<Scalars['Int']>;
  mileageInterval?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
  score?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

export type BidCondition = {
  __typename?: 'BidCondition';
  id?: Maybe<Scalars['ID']>;
  isAuto?: Maybe<Scalars['Boolean']>;
  isDisassembly?: Maybe<Scalars['Boolean']>;
  isMoto?: Maybe<Scalars['Boolean']>;
  isOnePrice?: Maybe<Scalars['Boolean']>;
  minYear?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type BoundaryLotsFilter = {
  lotAuctionDate?: Maybe<LotAuctionDateFilter>;
};

export type LotAuctionDateFilter = {
  eq?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  neq?: Maybe<Scalars['DateTime']>;
};

export type LotPaginatedList = {
  __typename?: 'LotPaginatedList';
  nodes: Array<Lot>;
  total: Scalars['Int'];
};

export type Lot = {
  __typename?: 'Lot';
  auctionDate?: Maybe<Scalars['DateTime']>;
  auctionDatetime?: Maybe<Scalars['DateTime']>;
  auctionName?: Maybe<Scalars['String']>;
  auctionSystem?: Maybe<Scalars['String']>;
  bestBid?: Maybe<Bid>;
  biddersCount?: Maybe<Scalars['Int']>;
  bids?: Maybe<Array<Bid>>;
  bidsCount?: Maybe<Scalars['Int']>;
  canEditNegotiationsPrice?: Maybe<Scalars['Boolean']>;
  canOpenNegotiations?: Maybe<Scalars['Boolean']>;
  canRecognizeAuctionList?: Maybe<Scalars['Boolean']>;
  canToggleTranslationsHidden?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  colorEn?: Maybe<Scalars['String']>;
  companyEn?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentUserHasHappyTime?: Maybe<Scalars['Boolean']>;
  currentUserLastBid?: Maybe<Bid>;
  currentUserLastLotSourceView?: Maybe<LotSourceView>;
  currentUserLimitsOverrideAvailable?: Maybe<Scalars['Boolean']>;
  currentUserLotBidsLimitReached?: Maybe<Scalars['Boolean']>;
  currentUserLotMarks?: Maybe<Array<UserLotMark>>;
  currentUserLotNote?: Maybe<LotNote>;
  description?: Maybe<Scalars['String']>;
  endPriceNum?: Maybe<Scalars['String']>;
  engineVolumeNum?: Maybe<Scalars['Int']>;
  equipmentEn?: Maybe<Scalars['String']>;
  expectedTranslationInSeconds?: Maybe<Scalars['Int']>;
  hasBestBid?: Maybe<Scalars['Boolean']>;
  hasTranslations?: Maybe<Scalars['Boolean']>;
  icons?: Maybe<Array<LotIconEnum>>;
  id?: Maybe<Scalars['LotID']>;
  images?: Maybe<Array<Scalars['String']>>;
  inFavoritesCount?: Maybe<Scalars['Int']>;
  isRestricted?: Maybe<Scalars['Boolean']>;
  jupiterLotData?: Maybe<Scalars['JSON']>;
  kawasakiLotData?: Maybe<Scalars['JSON']>;
  latestBid?: Maybe<Scalars['Int']>;
  link?: Maybe<Scalars['String']>;
  lotSetting?: Maybe<LotSetting>;
  lotSourceViews?: Maybe<Array<LotSourceView>>;
  mileageNum?: Maybe<Scalars['String']>;
  modelDetailsEn?: Maybe<Scalars['String']>;
  modelEn?: Maybe<Scalars['String']>;
  modelGradeEn?: Maybe<Scalars['String']>;
  modelTypeEn?: Maybe<Scalars['String']>;
  modelYearEn?: Maybe<Scalars['String']>;
  negotiationsAvailable?: Maybe<Scalars['Boolean']>;
  negotiationsEndsAt?: Maybe<Scalars['DateTime']>;
  negotiationsPrice?: Maybe<Scalars['BigInt']>;
  productionDate?: Maybe<Scalars['DateTime']>;
  productionDatePayload?: Maybe<Scalars['JSON']>;
  ratingEn?: Maybe<Scalars['String']>;
  soldPrice?: Maybe<Scalars['BigInt']>;
  startPriceNum?: Maybe<Scalars['String']>;
  status?: Maybe<LotStatusEnum>;
  subgroup?: Maybe<LotTypeEnum>;
  thumbnails?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
  /** Whether the manager closure currently blocks bids. Other bidding restrictions still apply. */
  tradingClosed?: Maybe<Scalars['Boolean']>;
  /** Manager closure cutoff, including the 30-minute buffer, matched by the lot's auction and Japan auction date; remains visible after that date. */
  tradingClosureBiddingEndsAt?: Maybe<Scalars['DateTime']>;
  translations?: Maybe<Array<LotTranslation>>;
  transmissionEn?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versions?: Maybe<Array<TrailEvent>>;
  viewsCount?: Maybe<Scalars['Int']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type Bid = {
  __typename?: 'Bid';
  amount?: Maybe<Scalars['Float']>;
  bidCondition?: Maybe<BidCondition>;
  bidGroup?: Maybe<BidGroup>;
  comments?: Maybe<Array<BidComment>>;
  commission?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createTranslation?: Maybe<Scalars['Boolean']>;
  fullAmount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  isByCurrentUser?: Maybe<Scalars['Boolean']>;
  isGreenCorner?: Maybe<Scalars['Boolean']>;
  isNegotiationsAccepted?: Maybe<Scalars['Boolean']>;
  isParticipationAccepted?: Maybe<Scalars['Boolean']>;
  lot?: Maybe<Lot>;
  needPriorityPass?: Maybe<Scalars['Boolean']>;
  notify?: Maybe<Scalars['Boolean']>;
  nowBest?: Maybe<Scalars['Boolean']>;
  status?: Maybe<BidStatusEnum>;
  translationComplete?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserInfo>;
  wasOverbid?: Maybe<Scalars['Boolean']>;
};

export type BidGroup = {
  __typename?: 'BidGroup';
  bidsLimitReached: Scalars['Boolean'];
  date: Scalars['DateTime'];
  id?: Maybe<Scalars['ID']>;
  letter: Scalars['String'];
  lotsLimitReached: Scalars['Boolean'];
  quantity: Scalars['String'];
};

export type BidComment = {
  __typename?: 'BidComment';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  isManager?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserInfo>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  fullName?: Maybe<Scalars['String']>;
  hasActiveBestBidViewServiceSubscription?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  username?: Maybe<Scalars['String']>;
};

export enum BidStatusEnum {
  Canceled = 'canceled',
  Confirmed = 'confirmed',
  Initial = 'initial',
  Won = 'won'
}

export type LotSourceView = {
  __typename?: 'LotSourceView';
  createdAt: Scalars['DateTime'];
  id?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['DateTime'];
  user: UserInfo;
};

export type UserLotMark = {
  __typename?: 'UserLotMark';
  id?: Maybe<Scalars['ID']>;
  lot?: Maybe<Lot>;
  mark?: Maybe<UserLotMarkEnum>;
  userLotMarksListTitle?: Maybe<Scalars['String']>;
  viewsCount?: Maybe<Scalars['Int']>;
};

export enum UserLotMarkEnum {
  Interesting = 'interesting',
  Shared = 'shared',
  Uninteresting = 'uninteresting'
}

export type LotNote = {
  __typename?: 'LotNote';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  lotId?: Maybe<Scalars['ID']>;
  note?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['ID']>;
};

export enum LotIconEnum {
  Check = 'check',
  Damaged = 'damaged',
  DashboardLampOn = 'dashboard_lamp_on',
  Diesel = 'diesel',
  Drowned = 'drowned',
  EquippedForDisabled = 'equipped_for_disabled',
  Forklift = 'forklift',
  LeftDrive = 'left_drive',
  NaturalGas = 'natural_gas',
  Repainted = 'repainted',
  Sanctions = 'sanctions',
  SecondKeys = 'second_keys'
}

export type LotSetting = {
  __typename?: 'LotSetting';
  id?: Maybe<Scalars['LotID']>;
  translationsHidden?: Maybe<Scalars['Boolean']>;
};

export enum LotStatusEnum {
  Canceled = 'canceled',
  Initial = 'initial',
  NegotiationSold = 'negotiation_sold',
  Negotiations = 'negotiations',
  Removed = 'removed',
  Sold = 'sold',
  Unsold = 'unsold',
  Won = 'won'
}

export enum LotTypeEnum {
  Auto = 'auto',
  Moto = 'moto',
  Oneprice = 'oneprice'
}

export type LotTranslation = {
  __typename?: 'LotTranslation';
  aiModel?: Maybe<Scalars['String']>;
  aiProvider?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentUserTranslationFeedback?: Maybe<TranslationFeedback>;
  dislikesCount?: Maybe<Scalars['Int']>;
  file?: Maybe<S3File>;
  id?: Maybe<Scalars['ID']>;
  language?: Maybe<Scalars['String']>;
  likesCount?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  translatorId?: Maybe<Scalars['ID']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TranslationFeedback = {
  __typename?: 'TranslationFeedback';
  akebonoLotTranslationId?: Maybe<Scalars['ID']>;
  feedbackType?: Maybe<TranslationFeedbackTypeEnum>;
  id?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
};

export enum TranslationFeedbackTypeEnum {
  Dislike = 'dislike',
  Like = 'like'
}

export type S3File = {
  __typename?: 'S3File';
  filename?: Maybe<Scalars['String']>;
  fullPath?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  key?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type TrailEvent = {
  __typename?: 'TrailEvent';
  author?: Maybe<TrailEventAuthor>;
  changeset?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  reason?: Maybe<Scalars['String']>;
  versionNumber?: Maybe<Scalars['Int']>;
};

export type TrailEventAuthor = {
  __typename?: 'TrailEventAuthor';
  countryIso?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  username?: Maybe<Scalars['String']>;
};

export enum LotSource {
  Aleado = 'aleado',
  Aucnet = 'aucnet',
  Manual = 'manual',
  Mikhail = 'mikhail'
}

export type Country = {
  __typename?: 'Country';
  alpha2: Scalars['String'];
  name: Scalars['String'];
};

export type CurrentUser = {
  __typename?: 'CurrentUser';
  acceptedAgreements?: Maybe<Array<Agreement>>;
  addresses?: Maybe<Array<Address>>;
  bestBidViewServiceSubscription?: Maybe<ServiceSubscription>;
  bidGroups?: Maybe<BidGroupPaginatedList>;
  bids?: Maybe<BidPaginatedList>;
  bidTranslationByDefault?: Maybe<Scalars['Boolean']>;
  birthdate?: Maybe<Scalars['String']>;
  birthdayToday?: Maybe<Scalars['Boolean']>;
  countryIso?: Maybe<Scalars['String']>;
  defaultBidConditionId?: Maybe<Scalars['ID']>;
  defaultTranslationMediaType?: Maybe<TranslationMediaTypeEnum>;
  fullName?: Maybe<Scalars['String']>;
  hasActiveGuidanceRequest?: Maybe<Scalars['Boolean']>;
  hasNotAcceptedAgreements?: Maybe<Scalars['Boolean']>;
  hasPermission?: Maybe<Scalars['Boolean']>;
  hasPermissions?: Maybe<Scalars['Boolean']>;
  hideBidAmount?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  ignoreSmallBidWarning?: Maybe<Scalars['Boolean']>;
  isEnoughFundsToSubscribeToViewTheBestBid?: Maybe<Scalars['Boolean']>;
  isOtherCountries?: Maybe<Scalars['Boolean']>;
  isTrusted?: Maybe<Scalars['Boolean']>;
  limitAkebonoLotProductionDateCheckRequestsDaily?: Maybe<Scalars['Int']>;
  limitLotBids?: Maybe<Scalars['Int']>;
  limitLotsDaily?: Maybe<Scalars['Int']>;
  limitLotsPerGroup?: Maybe<Scalars['Int']>;
  limitLotTranslationRequestsDaily?: Maybe<Scalars['Int']>;
  lotMarks?: Maybe<UserLotMarkPaginatedList>;
  lotMarksList?: Maybe<UserLotMarksList>;
  lotMarksLists?: Maybe<Array<UserLotMarksList>>;
  lotProductionDateCheckRequestsLimitReached?: Maybe<Scalars['Boolean']>;
  lotsLimitReached?: Maybe<Scalars['Boolean']>;
  lotTranslationRequestsLimitReached?: Maybe<Scalars['Boolean']>;
  maxBidAmountLimit?: Maybe<Scalars['Int']>;
  notAcceptedAgreements?: Maybe<Array<Agreement>>;
  notificationSettings?: Maybe<Scalars['JSON']>;
  officeBranch?: Maybe<OfficeBranch>;
  permissions?: Maybe<Array<Permission>>;
  plan?: Maybe<Plan>;
  preferredLang?: Maybe<PreferredLang>;
  requests?: Maybe<UserRequestUnionPaginatedList>;
  userChannel?: Maybe<UserChannel>;
  userFilterPresets?: Maybe<Array<UserFilterPreset>>;
  username?: Maybe<Scalars['String']>;
};


export type CurrentUserBidGroupsArgs = {
  filter?: Maybe<AutoCurrentUserBidGroupsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<AutoCurrentUserBidGroupsSort>;
};


export type CurrentUserBidsArgs = {
  filter?: Maybe<AutoCurrentUserBidsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<AutoCurrentUserBidsSort>;
};


export type CurrentUserHasPermissionArgs = {
  code: Scalars['String'];
};


export type CurrentUserHasPermissionsArgs = {
  codes: Array<Scalars['String']>;
};


export type CurrentUserLotMarksArgs = {
  filter?: Maybe<AutoCurrentUserLotMarksFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<AutoCurrentUserLotMarksSort>;
};


export type CurrentUserLotMarksListArgs = {
  id: Scalars['ID'];
};


export type CurrentUserLotProductionDateCheckRequestsLimitReachedArgs = {
  auctionDate: Scalars['DateTime'];
};


export type CurrentUserLotsLimitReachedArgs = {
  auctionDate: Scalars['DateTime'];
};


export type CurrentUserLotTranslationRequestsLimitReachedArgs = {
  auctionDate: Scalars['DateTime'];
};


export type CurrentUserRequestsArgs = {
  filter?: Maybe<AutoCurrentUserRequestsFilter>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};

export type Agreement = {
  __typename?: 'Agreement';
  contentEn?: Maybe<Scalars['String']>;
  contentRu?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isAccepted?: Maybe<Scalars['Boolean']>;
  titleEn?: Maybe<Scalars['String']>;
  titleRu?: Maybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  countryIso?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  passportDateOfBirth?: Maybe<Scalars['String']>;
  passportDateOfIssue?: Maybe<Scalars['String']>;
  passportIssuer?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  passportSerial?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tin?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type ServiceSubscription = {
  __typename?: 'ServiceSubscription';
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  serviceId?: Maybe<Scalars['ID']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['ID']>;
};

export type AutoCurrentUserBidGroupsFilter = {
  date?: Maybe<DateFilter>;
};

export type DateFilter = {
  eq?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  neq?: Maybe<Scalars['DateTime']>;
};

export type AutoCurrentUserBidGroupsSort = {
  createdAt?: Maybe<CreatedAtSort>;
  updatedAt?: Maybe<UpdatedAtSort>;
};

export type CreatedAtSort = {
  direction?: Maybe<Scalars['String']>;
};

export type UpdatedAtSort = {
  direction?: Maybe<Scalars['String']>;
};

export type BidGroupPaginatedList = {
  __typename?: 'BidGroupPaginatedList';
  nodes: Array<BidGroup>;
  total: Scalars['Int'];
};

export type AutoCurrentUserBidsFilter = {
  bidCondition?: Maybe<BidConditionFilter>;
  bidCreateTranslation?: Maybe<BidCreateTranslationFilter>;
  bidGroupLetter?: Maybe<BidGroupLetterFilter>;
  bidIsParticipationAccepted?: Maybe<BidIsParticipationAcceptedFilter>;
  bidLotAuctionDate?: Maybe<BidLotAuctionDateFilter>;
  bidLotAuctionName?: Maybe<BidLotAuctionNameFilter>;
  bidLotCode?: Maybe<BidLotCodeFilter>;
  bidLotCompanyEn?: Maybe<BidLotCompanyEnFilter>;
  bidLotModelEn?: Maybe<BidLotModelEnFilter>;
  bidLotModelTypeEn?: Maybe<BidLotModelTypeEnFilter>;
  bidLotTranslationsCount?: Maybe<BidLotTranslationsCountFilter>;
  bidStatus?: Maybe<BidStatusFilter>;
  createdAt?: Maybe<CreatedAtFilter>;
};

export type BidConditionFilter = {
  eq?: Maybe<Scalars['ID']>;
};

export type BidCreateTranslationFilter = {
  eq?: Maybe<Scalars['Boolean']>;
};

export type BidGroupLetterFilter = {
  eq?: Maybe<Scalars['String']>;
};

export type BidIsParticipationAcceptedFilter = {
  eq?: Maybe<Scalars['Boolean']>;
};

export type BidLotAuctionDateFilter = {
  eq?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  neq?: Maybe<Scalars['DateTime']>;
};

export type BidLotAuctionNameFilter = {
  like?: Maybe<Scalars['String']>;
};

export type BidLotCodeFilter = {
  eq?: Maybe<Scalars['String']>;
};

export type BidLotCompanyEnFilter = {
  eq?: Maybe<Scalars['String']>;
};

export type BidLotModelEnFilter = {
  eq?: Maybe<Scalars['String']>;
};

export type BidLotModelTypeEnFilter = {
  eq?: Maybe<Scalars['String']>;
};

export type BidLotTranslationsCountFilter = {
  gte?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
};

export type BidStatusFilter = {
  eq?: Maybe<BidStatusEnum>;
};

export type CreatedAtFilter = {
  eq?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  neq?: Maybe<Scalars['DateTime']>;
};

export type AutoCurrentUserBidsSort = {
  bidCondition?: Maybe<BidConditionSort>;
  bidGroup?: Maybe<BidGroupSort>;
  bidLotAuctionDatetime?: Maybe<BidLotAuctionDatetimeSort>;
  createdAt?: Maybe<CreatedAtSort>;
  updatedAt?: Maybe<UpdatedAtSort>;
};

export type BidConditionSort = {
  direction?: Maybe<Scalars['String']>;
};

export type BidGroupSort = {
  direction?: Maybe<Scalars['String']>;
};

export type BidLotAuctionDatetimeSort = {
  direction?: Maybe<Scalars['String']>;
};

export type BidPaginatedList = {
  __typename?: 'BidPaginatedList';
  nodes: Array<Bid>;
  total: Scalars['Int'];
};

export enum TranslationMediaTypeEnum {
  Audio = 'audio',
  Text = 'text'
}

export type AutoCurrentUserLotMarksFilter = {
  bidLotType?: Maybe<BidLotTypeFilter>;
  lotSource?: Maybe<LotSourceFilter>;
  userLotMark?: Maybe<UserLotMarkFilter>;
  userLotMarksListId?: Maybe<UserLotMarksListIdFilter>;
};

export type BidLotTypeFilter = {
  eq?: Maybe<LotTypeEnum>;
};

export type LotSourceFilter = {
  eq?: Maybe<LotSource>;
};

export type UserLotMarkFilter = {
  eq?: Maybe<UserLotMarkEnum>;
};

export type UserLotMarksListIdFilter = {
  eq?: Maybe<Scalars['ID']>;
};

export type AutoCurrentUserLotMarksSort = {
  bidLotAuctionDatetime?: Maybe<BidLotAuctionDatetimeSort>;
};

export type UserLotMarkPaginatedList = {
  __typename?: 'UserLotMarkPaginatedList';
  nodes: Array<UserLotMark>;
  total: Scalars['Int'];
};

export type UserLotMarksList = {
  __typename?: 'UserLotMarksList';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  images?: Maybe<Array<Scalars['String']>>;
  lotMarks?: Maybe<Array<UserLotMark>>;
  path?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
};

export type OfficeBranch = {
  __typename?: 'OfficeBranch';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isWorldwide?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type Permission = {
  __typename?: 'Permission';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Int']>;
};

export type Plan = {
  __typename?: 'Plan';
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['SecureString']>;
};

export enum PreferredLang {
  En = 'en',
  Ru = 'ru'
}

export type AutoCurrentUserRequestsFilter = {
  userRequestStatus?: Maybe<UserRequestStatusFilter>;
  userRequestType?: Maybe<UserRequestTypeFilter>;
};

export type UserRequestStatusFilter = {
  eq?: Maybe<UserRequestStatusEnum>;
};

export enum UserRequestStatusEnum {
  Deleted = 'deleted',
  Initial = 'initial',
  Processed = 'processed',
  Rejected = 'rejected'
}

export type UserRequestTypeFilter = {
  eq?: Maybe<UserRequestTypeEnum>;
};

export enum UserRequestTypeEnum {
  BidDeleteRequest = 'BidDeleteRequest',
  GuidanceRequest = 'GuidanceRequest',
  LotPhotoRequest = 'LotPhotoRequest',
  LotProductionDateCheckRequest = 'LotProductionDateCheckRequest',
  LotsAccessRequest = 'LotsAccessRequest',
  LotTranslateRequest = 'LotTranslateRequest',
  PlugViewBestBidSubscriptionOnAdvanceUpdateRequest = 'PlugViewBestBidSubscriptionOnAdvanceUpdateRequest'
}

export type UserRequestUnionPaginatedList = {
  __typename?: 'UserRequestUnionPaginatedList';
  nodes: Array<UserRequestUnion>;
  total: Scalars['Int'];
};

export type UserRequestUnion = BidDeleteRequest | LotProductionDateCheckRequest | LotTranslateRequest;

export type BidDeleteRequest = UserRequestInterface & {
  __typename?: 'BidDeleteRequest';
  bid?: Maybe<Bid>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<UserRequestStatusEnum>;
  type?: Maybe<UserRequestTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<CurrentUser>;
};

export type UserRequestInterface = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<UserRequestStatusEnum>;
  type?: Maybe<UserRequestTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<CurrentUser>;
};

export type LotProductionDateCheckRequest = UserRequestInterface & {
  __typename?: 'LotProductionDateCheckRequest';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  lot?: Maybe<Lot>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<UserRequestStatusEnum>;
  type?: Maybe<UserRequestTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<CurrentUser>;
};

export type LotTranslateRequest = UserRequestInterface & {
  __typename?: 'LotTranslateRequest';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  lot?: Maybe<Lot>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<UserRequestStatusEnum>;
  targetLanguage?: Maybe<TranslationLanguage>;
  targetType?: Maybe<TranslationMediaTypeEnum>;
  type?: Maybe<UserRequestTypeEnum>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<CurrentUser>;
};

export enum TranslationLanguage {
  En = 'en',
  Ru = 'ru'
}

export type UserChannel = {
  __typename?: 'UserChannel';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  images?: Maybe<Array<Scalars['String']>>;
  path?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['ID']>;
  userLotMarksLists?: Maybe<Array<UserLotMarksList>>;
};

export type UserFilterPreset = {
  __typename?: 'UserFilterPreset';
  compilationEmailEnabled?: Maybe<Scalars['Boolean']>;
  content?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
};

export enum CurrencyEnum {
  /** Euro */
  Eur = 'EUR',
  /** Japan Yen */
  Jpy = 'JPY',
  /** US Dollar */
  Usd = 'USD'
}

export type ExchangeRate = {
  __typename?: 'ExchangeRate';
  date: Scalars['DateTime'];
  nominal: Scalars['Float'];
  value: Scalars['Float'];
};

export type LotsFilter = {
  lotAuctionDate?: Maybe<LotAuctionDateFilter>;
  lotAuctionName?: Maybe<LotAuctionNameFilter>;
  lotCode?: Maybe<LotCodeFilter>;
  lotCodeDateAuctionName?: Maybe<LotCodeDateAuctionNameFilter>;
  lotColorEn?: Maybe<LotColorEnFilter>;
  lotCompanyEn?: Maybe<LotCompanyEnFilter>;
  lotMark?: Maybe<LotMarkFilter>;
  lotMileageNum?: Maybe<LotMileageNumFilter>;
  lotModelEn?: Maybe<LotModelEnFilter>;
  lotModelTypeEn?: Maybe<LotModelTypeEnFilter>;
  lotOriginalIds?: Maybe<LotOriginalIdsFilter>;
  lotRatingEn?: Maybe<LotRatingEnFilter>;
  lotSource?: Maybe<LotSourceFilter>;
  lotType?: Maybe<LotTypeFilter>;
  lotYear?: Maybe<LotYearFilter>;
};

export type LotAuctionNameFilter = {
  eq?: Maybe<Scalars['String']>;
};

export type LotCodeFilter = {
  eq?: Maybe<Scalars['String']>;
};

export type LotCodeDateAuctionNameFilter = {
  eq?: Maybe<Array<CodeDateAuctionNameInput>>;
};

export type CodeDateAuctionNameInput = {
  auctionName: Scalars['String'];
  code: Scalars['String'];
  date: Scalars['String'];
};

export type LotColorEnFilter = {
  eq?: Maybe<Scalars['String']>;
};

export type LotCompanyEnFilter = {
  eq?: Maybe<Scalars['String']>;
};

export type LotMarkFilter = {
  eq?: Maybe<Array<LotMarkEnum>>;
};

export enum LotMarkEnum {
  Interesting = 'INTERESTING',
  Shared = 'SHARED',
  Uninteresting = 'UNINTERESTING'
}

export type LotMileageNumFilter = {
  eq?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  neq?: Maybe<Scalars['Int']>;
};

export type LotModelEnFilter = {
  eq?: Maybe<Scalars['String']>;
};

export type LotModelTypeEnFilter = {
  eq?: Maybe<Scalars['String']>;
};

export type LotOriginalIdsFilter = {
  eq?: Maybe<Array<Scalars['String']>>;
};

export type LotRatingEnFilter = {
  eq?: Maybe<Scalars['String']>;
};

export type LotTypeFilter = {
  eq?: Maybe<LotTypeEnum>;
};

export type LotYearFilter = {
  eq?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  neq?: Maybe<Scalars['Int']>;
};

export type LotsSort = {
  auctionDatetime?: Maybe<AuctionDatetimeSort>;
  auctionName?: Maybe<AuctionNameSort>;
  code?: Maybe<CodeSort>;
  colorEn?: Maybe<ColorEnSort>;
  endPriceNum?: Maybe<EndPriceNumSort>;
  engineVolumeNum?: Maybe<EngineVolumeNumSort>;
  equipmentEn?: Maybe<EquipmentEnSort>;
  mileageNum?: Maybe<MileageNumSort>;
  modelTypeEn?: Maybe<ModelTypeEnSort>;
  modelYearEn?: Maybe<ModelYearEnSort>;
  ratingEn?: Maybe<RatingEnSort>;
  startPriceNum?: Maybe<StartPriceNumSort>;
};

export type AuctionDatetimeSort = {
  direction?: Maybe<Scalars['String']>;
};

export type AuctionNameSort = {
  direction?: Maybe<Scalars['String']>;
};

export type CodeSort = {
  direction?: Maybe<Scalars['String']>;
};

export type ColorEnSort = {
  direction?: Maybe<Scalars['String']>;
};

export type EndPriceNumSort = {
  direction?: Maybe<Scalars['String']>;
};

export type EngineVolumeNumSort = {
  direction?: Maybe<Scalars['String']>;
};

export type EquipmentEnSort = {
  direction?: Maybe<Scalars['String']>;
};

export type MileageNumSort = {
  direction?: Maybe<Scalars['String']>;
};

export type ModelTypeEnSort = {
  direction?: Maybe<Scalars['String']>;
};

export type ModelYearEnSort = {
  direction?: Maybe<Scalars['String']>;
};

export type RatingEnSort = {
  direction?: Maybe<Scalars['String']>;
};

export type StartPriceNumSort = {
  direction?: Maybe<Scalars['String']>;
};

export type LotInspectionInput = {
  id: Scalars['LotID'];
  source: LotSource;
  subgroup: LotTypeEnum;
};

export type LotInspection = {
  __typename?: 'LotInspection';
  id: Scalars['LotID'];
  inspected: Scalars['Boolean'];
  source: LotSource;
  subgroup: LotTypeEnum;
};

export type LotViewsCount = {
  __typename?: 'LotViewsCount';
  originalId: Scalars['LotID'];
  viewsCount: Scalars['Int'];
};

export type UserRequestsFilter = {
  userRequestStatus?: Maybe<UserRequestStatusFilter>;
  userRequestType?: Maybe<UserRequestTypeFilter>;
};

export type VincheckerInfo = {
  __typename?: 'VincheckerInfo';
  chassisId?: Maybe<Scalars['String']>;
  maker?: Maybe<Scalars['String']>;
  necessaryDigitInBodyNumber?: Maybe<Scalars['String']>;
  rangeEndDate?: Maybe<Scalars['String']>;
  rangeStartDate?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptAgreement?: Maybe<AcceptAgreementPayload>;
  baseAuctionsMutation?: Maybe<BaseAuctionsMutationPayload>;
  baseOpenMutation?: Maybe<BaseOpenMutationPayload>;
  bidCommentCreate?: Maybe<BidCommentCreatePayload>;
  bidCreate?: Maybe<BidCreatePayload>;
  bidCreateForUser?: Maybe<BidCreateForUserPayload>;
  bidCreateManual?: Maybe<BidCreateManualPayload>;
  bidCreateManualForUser?: Maybe<BidCreateManualForUserPayload>;
  bidDeleteRequestCreate?: Maybe<BidDeleteRequestCreatePayload>;
  bidGroupCreate?: Maybe<BidGroupCreatePayload>;
  bidUpdate?: Maybe<BidUpdatePayload>;
  guidanceRequestCreate?: Maybe<GuidanceRequestCreatePayload>;
  lotAiTranslationCreate?: Maybe<LotAiTranslationCreatePayload>;
  lotAraiKenkiPhotoFetch?: Maybe<LotAraiKenkiPhotoFetchPayload>;
  lotAutoTranslationCreate?: Maybe<LotAutoTranslationCreatePayload>;
  lotCreateManual?: Maybe<LotCreateManualPayload>;
  lotIncrementViewsCount?: Maybe<LotIncrementViewsCountPayload>;
  lotNegotiationsOpen?: Maybe<LotNegotiationsOpenPayload>;
  lotNoteCreate?: Maybe<LotNoteCreatePayload>;
  lotNoteDelete?: Maybe<LotNoteDeletePayload>;
  lotNoteUpdate?: Maybe<LotNoteUpdatePayload>;
  lotPhotoBotRequest?: Maybe<LotPhotoBotRequestPayload>;
  lotPhotoFetch?: Maybe<LotPhotoFetchPayload>;
  lotPhotoRequest?: Maybe<LotPhotoRequestPayload>;
  lotProductionDateCheckRequestCreate?: Maybe<LotProductionDateCheckRequestCreatePayload>;
  lotProductionDateFetch?: Maybe<LotProductionDateFetchPayload>;
  lotReset?: Maybe<LotResetPayload>;
  lotSettingsUpdate?: Maybe<LotSettingsUpdatePayload>;
  lotTranslateRequestCreate?: Maybe<LotTranslateRequestCreatePayload>;
  lotUpdate?: Maybe<LotUpdatePayload>;
  notificationSettingsUpdate?: Maybe<NotificationSettingsUpdatePayload>;
  plugViewBestBidSubscriptionOnAdvanceUpdateRequestCreate?: Maybe<PlugViewBestBidSubscriptionOnAdvanceUpdateRequestCreatePayload>;
  presignedPostCreate?: Maybe<PresignedPostCreatePayload>;
  productionDateFetch?: Maybe<ProductionDateFetchPayload>;
  translationFeedbackCreate?: Maybe<TranslationFeedbackCreatePayload>;
  translationFeedbackDelete?: Maybe<TranslationFeedbackDeletePayload>;
  translationFeedbackUpdate?: Maybe<TranslationFeedbackUpdatePayload>;
  userChannelCreate?: Maybe<UserChannelCreatePayload>;
  userChannelDelete?: Maybe<UserChannelDeletePayload>;
  userChannelUpdate?: Maybe<UserChannelUpdatePayload>;
  userFilterPresetCreate?: Maybe<UserFilterPresetCreatePayload>;
  userFilterPresetDelete?: Maybe<UserFilterPresetDeletePayload>;
  userFilterPresetUpdate?: Maybe<UserFilterPresetUpdatePayload>;
  userLotMarkCreate?: Maybe<UserLotMarkCreatePayload>;
  userLotMarkDelete?: Maybe<UserLotMarkDeletePayload>;
  userLotMarksListClear?: Maybe<UserLotMarksListClearPayload>;
  userLotMarksListCreate?: Maybe<UserLotMarksListCreatePayload>;
  userLotMarksListDelete?: Maybe<UserLotMarksListDeletePayload>;
  userLotMarksListFill?: Maybe<UserLotMarksListFillPayload>;
  userLotMarksListUpdate?: Maybe<UserLotMarksListUpdatePayload>;
  userLotMarksUpdate?: Maybe<UserLotMarksUpdatePayload>;
  userLotMarkUpdate?: Maybe<UserLotMarkUpdatePayload>;
  userUpdate?: Maybe<UserUpdatePayload>;
  userViewBestBidSubscribe?: Maybe<UserViewBestBidSubscribePayload>;
};


export type MutationAcceptAgreementArgs = {
  input: AcceptAgreementInput;
};


export type MutationBaseAuctionsMutationArgs = {
  input: BaseAuctionsMutationInput;
};


export type MutationBaseOpenMutationArgs = {
  input: BaseOpenMutationInput;
};


export type MutationBidCommentCreateArgs = {
  input: BidCommentCreateInput;
};


export type MutationBidCreateArgs = {
  input: BidCreateInput;
};


export type MutationBidCreateForUserArgs = {
  input: BidCreateForUserInput;
};


export type MutationBidCreateManualArgs = {
  input: BidCreateManualInput;
};


export type MutationBidCreateManualForUserArgs = {
  input: BidCreateManualForUserInput;
};


export type MutationBidDeleteRequestCreateArgs = {
  input: BidDeleteRequestCreateInput;
};


export type MutationBidGroupCreateArgs = {
  input: BidGroupCreateInput;
};


export type MutationBidUpdateArgs = {
  input: BidUpdateInput;
};


export type MutationGuidanceRequestCreateArgs = {
  input: GuidanceRequestCreateInput;
};


export type MutationLotAiTranslationCreateArgs = {
  input: LotAiTranslationCreateInput;
};


export type MutationLotAraiKenkiPhotoFetchArgs = {
  input: LotAraiKenkiPhotoFetchInput;
};


export type MutationLotAutoTranslationCreateArgs = {
  input: LotAutoTranslationCreateInput;
};


export type MutationLotCreateManualArgs = {
  input: LotCreateManualInput;
};


export type MutationLotIncrementViewsCountArgs = {
  input: LotIncrementViewsCountInput;
};


export type MutationLotNegotiationsOpenArgs = {
  input: LotNegotiationsOpenInput;
};


export type MutationLotNoteCreateArgs = {
  input: LotNoteCreateInput;
};


export type MutationLotNoteDeleteArgs = {
  input: LotNoteDeleteInput;
};


export type MutationLotNoteUpdateArgs = {
  input: LotNoteUpdateInput;
};


export type MutationLotPhotoBotRequestArgs = {
  input: LotPhotoBotRequestInput;
};


export type MutationLotPhotoFetchArgs = {
  input: LotPhotoFetchInput;
};


export type MutationLotPhotoRequestArgs = {
  input: LotPhotoRequestInput;
};


export type MutationLotProductionDateCheckRequestCreateArgs = {
  input: LotProductionDateCheckRequestCreateInput;
};


export type MutationLotProductionDateFetchArgs = {
  input: LotProductionDateFetchInput;
};


export type MutationLotResetArgs = {
  input: LotResetInput;
};


export type MutationLotSettingsUpdateArgs = {
  input: LotSettingsUpdateInput;
};


export type MutationLotTranslateRequestCreateArgs = {
  input: LotTranslateRequestCreateInput;
};


export type MutationLotUpdateArgs = {
  input: LotUpdateInput;
};


export type MutationNotificationSettingsUpdateArgs = {
  input: NotificationSettingsUpdateInput;
};


export type MutationPlugViewBestBidSubscriptionOnAdvanceUpdateRequestCreateArgs = {
  input: PlugViewBestBidSubscriptionOnAdvanceUpdateRequestCreateInput;
};


export type MutationPresignedPostCreateArgs = {
  input: PresignedPostCreateInput;
};


export type MutationProductionDateFetchArgs = {
  input: ProductionDateFetchInput;
};


export type MutationTranslationFeedbackCreateArgs = {
  input: TranslationFeedbackCreateInput;
};


export type MutationTranslationFeedbackDeleteArgs = {
  input: TranslationFeedbackDeleteInput;
};


export type MutationTranslationFeedbackUpdateArgs = {
  input: TranslationFeedbackUpdateInput;
};


export type MutationUserChannelCreateArgs = {
  input: UserChannelCreateInput;
};


export type MutationUserChannelDeleteArgs = {
  input: UserChannelDeleteInput;
};


export type MutationUserChannelUpdateArgs = {
  input: UserChannelUpdateInput;
};


export type MutationUserFilterPresetCreateArgs = {
  input: UserFilterPresetCreateInput;
};


export type MutationUserFilterPresetDeleteArgs = {
  input: UserFilterPresetDeleteInput;
};


export type MutationUserFilterPresetUpdateArgs = {
  input: UserFilterPresetUpdateInput;
};


export type MutationUserLotMarkCreateArgs = {
  input: UserLotMarkCreateInput;
};


export type MutationUserLotMarkDeleteArgs = {
  input: UserLotMarkDeleteInput;
};


export type MutationUserLotMarksListClearArgs = {
  input: UserLotMarksListClearInput;
};


export type MutationUserLotMarksListCreateArgs = {
  input: UserLotMarksListCreateInput;
};


export type MutationUserLotMarksListDeleteArgs = {
  input: UserLotMarksListDeleteInput;
};


export type MutationUserLotMarksListFillArgs = {
  input: UserLotMarksListFillInput;
};


export type MutationUserLotMarksListUpdateArgs = {
  input: UserLotMarksListUpdateInput;
};


export type MutationUserLotMarksUpdateArgs = {
  input: UserLotMarksUpdateInput;
};


export type MutationUserLotMarkUpdateArgs = {
  input: UserLotMarkUpdateInput;
};


export type MutationUserUpdateArgs = {
  input: UserUpdateInput;
};


export type MutationUserViewBestBidSubscribeArgs = {
  input: UserViewBestBidSubscribeInput;
};

/** Autogenerated input type of AcceptAgreement */
export type AcceptAgreementInput = {
  agreementId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of AcceptAgreement. */
export type AcceptAgreementPayload = {
  __typename?: 'AcceptAgreementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

export type Error = {
  __typename?: 'Error';
  backtrace?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of BaseAuctionsMutation */
export type BaseAuctionsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of BaseAuctionsMutation. */
export type BaseAuctionsMutationPayload = {
  __typename?: 'BaseAuctionsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of BaseOpenMutation */
export type BaseOpenMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of BaseOpenMutation. */
export type BaseOpenMutationPayload = {
  __typename?: 'BaseOpenMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of BidCommentCreate */
export type BidCommentCreateInput = {
  bidId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  content: Scalars['SecureString'];
};

/** Autogenerated return type of BidCommentCreate. */
export type BidCommentCreatePayload = {
  __typename?: 'BidCommentCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  comment: BidComment;
  error?: Maybe<Error>;
};

/** Autogenerated input type of BidCreate */
export type BidCreateInput = {
  amount: Scalars['Int'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  comment: Scalars['SecureString'];
  conditionId: Scalars['ID'];
  createTranslation: Scalars['Boolean'];
  groupId?: Maybe<Scalars['ID']>;
  isGreenCorner?: Maybe<Scalars['Boolean']>;
  lotId: Scalars['LotID'];
  lotSource: LotSource;
  lotType: LotTypeEnum;
  needPriorityPass?: Maybe<Scalars['Boolean']>;
  notify: Scalars['Boolean'];
  withLimitsOverride?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of BidCreate. */
export type BidCreatePayload = {
  __typename?: 'BidCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  hint?: Maybe<PlaceBidHint>;
};

export type PlaceBidHint = {
  __typename?: 'PlaceBidHint';
  text?: Maybe<Scalars['String']>;
  triesLeft?: Maybe<Scalars['Int']>;
};

/** Autogenerated input type of BidCreateForUser */
export type BidCreateForUserInput = {
  amount: Scalars['Int'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  comment: Scalars['SecureString'];
  conditionId: Scalars['ID'];
  createTranslation: Scalars['Boolean'];
  groupId?: Maybe<Scalars['ID']>;
  isGreenCorner?: Maybe<Scalars['Boolean']>;
  lotId: Scalars['LotID'];
  lotSource: LotSource;
  lotType: LotTypeEnum;
  needPriorityPass?: Maybe<Scalars['Boolean']>;
  notify: Scalars['Boolean'];
  userId: Scalars['ID'];
  withLimitsOverride?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of BidCreateForUser. */
export type BidCreateForUserPayload = {
  __typename?: 'BidCreateForUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of BidCreateManual */
export type BidCreateManualInput = {
  amount: Scalars['Int'];
  auctionDatetime: Scalars['DateTime'];
  auctionName: Scalars['String'];
  auctionSystem?: Maybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  comment: Scalars['SecureString'];
  company?: Maybe<Scalars['String']>;
  conditionId: Scalars['ID'];
  createTranslation: Scalars['Boolean'];
  displacementNum?: Maybe<Scalars['Int']>;
  endPrice?: Maybe<Scalars['Int']>;
  equipment?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  images?: Maybe<Array<Scalars['String']>>;
  isGreenCorner?: Maybe<Scalars['Boolean']>;
  lotType: LotTypeEnum;
  mileage?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  modelDetails?: Maybe<Scalars['String']>;
  modelGrade?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  needPriorityPass?: Maybe<Scalars['Boolean']>;
  notify: Scalars['Boolean'];
  scores?: Maybe<Scalars['String']>;
  startPrice: Scalars['Int'];
  transmission?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  withLimitsOverride?: Maybe<Scalars['Boolean']>;
  year?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of BidCreateManual. */
export type BidCreateManualPayload = {
  __typename?: 'BidCreateManualPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of BidCreateManualForUser */
export type BidCreateManualForUserInput = {
  amount: Scalars['Int'];
  auctionDatetime: Scalars['DateTime'];
  auctionName: Scalars['String'];
  auctionSystem?: Maybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  comment: Scalars['SecureString'];
  company?: Maybe<Scalars['String']>;
  conditionId: Scalars['ID'];
  createTranslation: Scalars['Boolean'];
  displacementNum?: Maybe<Scalars['Int']>;
  endPrice?: Maybe<Scalars['Int']>;
  equipment?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['ID']>;
  images?: Maybe<Array<Scalars['String']>>;
  isGreenCorner?: Maybe<Scalars['Boolean']>;
  lotType: Scalars['LotID'];
  mileage?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  modelDetails?: Maybe<Scalars['String']>;
  modelGrade?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  needPriorityPass?: Maybe<Scalars['Boolean']>;
  notify: Scalars['Boolean'];
  scores?: Maybe<Scalars['String']>;
  startPrice: Scalars['Int'];
  transmission?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
  vin?: Maybe<Scalars['String']>;
  withLimitsOverride?: Maybe<Scalars['Boolean']>;
  year?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of BidCreateManualForUser. */
export type BidCreateManualForUserPayload = {
  __typename?: 'BidCreateManualForUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of BidDeleteRequestCreate */
export type BidDeleteRequestCreateInput = {
  bidId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['SecureString']>;
};

/** Autogenerated return type of BidDeleteRequestCreate. */
export type BidDeleteRequestCreatePayload = {
  __typename?: 'BidDeleteRequestCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  userRequest?: Maybe<UserRequestUnion>;
};

/** Autogenerated input type of BidGroupCreate */
export type BidGroupCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  letter: Scalars['SecureString'];
  quantity: Scalars['Int'];
};

/** Autogenerated return type of BidGroupCreate. */
export type BidGroupCreatePayload = {
  __typename?: 'BidGroupCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  group?: Maybe<BidGroup>;
};

/** Autogenerated input type of BidUpdate */
export type BidUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['SecureString'];
  isNegotiationsAccepted?: Maybe<Scalars['Boolean']>;
  isParticipationAccepted?: Maybe<Scalars['Boolean']>;
  newAmount?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of BidUpdate. */
export type BidUpdatePayload = {
  __typename?: 'BidUpdatePayload';
  bid?: Maybe<Bid>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of GuidanceRequestCreate */
export type GuidanceRequestCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['SecureString']>;
};

/** Autogenerated return type of GuidanceRequestCreate. */
export type GuidanceRequestCreatePayload = {
  __typename?: 'GuidanceRequestCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of LotAiTranslationCreate */
export type LotAiTranslationCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  language: Scalars['SecureString'];
  lotId: Scalars['LotID'];
  lotSource: AkebonoLotSource;
  lotType: AkebonoLotTypeEnum;
};

export enum AkebonoLotSource {
  Aleado = 'aleado',
  Aucnet = 'aucnet',
  Manual = 'manual',
  Mikhail = 'mikhail',
  Mochiron = 'mochiron'
}

export enum AkebonoLotTypeEnum {
  Auto = 'auto',
  Moto = 'moto',
  Oneprice = 'oneprice',
  Truck = 'truck'
}

/** Autogenerated return type of LotAiTranslationCreate. */
export type LotAiTranslationCreatePayload = {
  __typename?: 'LotAiTranslationCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  lot?: Maybe<Lot>;
  messages: Array<Scalars['String']>;
};

/** Autogenerated input type of LotAraiKenkiPhotoFetch */
export type LotAraiKenkiPhotoFetchInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lotId: Scalars['LotID'];
  lotSource: LotSource;
  lotType: LotTypeEnum;
};

/** Autogenerated return type of LotAraiKenkiPhotoFetch. */
export type LotAraiKenkiPhotoFetchPayload = {
  __typename?: 'LotAraiKenkiPhotoFetchPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  lot?: Maybe<Lot>;
};

/** Autogenerated input type of LotAutoTranslationCreate */
export type LotAutoTranslationCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lotId: Scalars['LotID'];
  lotSource: LotSource;
  lotType: LotTypeEnum;
};

/** Autogenerated return type of LotAutoTranslationCreate. */
export type LotAutoTranslationCreatePayload = {
  __typename?: 'LotAutoTranslationCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  lot?: Maybe<Lot>;
};

/** Autogenerated input type of LotCreateManual */
export type LotCreateManualInput = {
  auctionDatetime: Scalars['DateTime'];
  auctionName: Scalars['String'];
  auctionSystem?: Maybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  color?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  displacementNum?: Maybe<Scalars['Int']>;
  endPrice?: Maybe<Scalars['Int']>;
  equipment?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Scalars['String']>>;
  lotType: LotTypeEnum;
  mileage?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  modelDetails?: Maybe<Scalars['String']>;
  modelGrade?: Maybe<Scalars['String']>;
  modelType?: Maybe<Scalars['String']>;
  scores?: Maybe<Scalars['String']>;
  startPrice: Scalars['Int'];
  transmission?: Maybe<Scalars['String']>;
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of LotCreateManual. */
export type LotCreateManualPayload = {
  __typename?: 'LotCreateManualPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of LotIncrementViewsCount */
export type LotIncrementViewsCountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lotId: Scalars['LotID'];
  lotSource: LotSource;
  lotType: LotTypeEnum;
};

/** Autogenerated return type of LotIncrementViewsCount. */
export type LotIncrementViewsCountPayload = {
  __typename?: 'LotIncrementViewsCountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of LotNegotiationsOpen */
export type LotNegotiationsOpenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lotId: Scalars['LotID'];
  lotSource: LotSource;
  lotType: LotTypeEnum;
  negotiationsPrice: Scalars['Int'];
};

/** Autogenerated return type of LotNegotiationsOpen. */
export type LotNegotiationsOpenPayload = {
  __typename?: 'LotNegotiationsOpenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  lot?: Maybe<Lot>;
};

/** Autogenerated input type of LotNoteCreate */
export type LotNoteCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lotId: Scalars['LotID'];
  lotSource: LotSource;
  lotType: LotTypeEnum;
  note: Scalars['String'];
};

/** Autogenerated return type of LotNoteCreate. */
export type LotNoteCreatePayload = {
  __typename?: 'LotNoteCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of LotNoteDelete */
export type LotNoteDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of LotNoteDelete. */
export type LotNoteDeletePayload = {
  __typename?: 'LotNoteDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of LotNoteUpdate */
export type LotNoteUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  note: Scalars['String'];
};

/** Autogenerated return type of LotNoteUpdate. */
export type LotNoteUpdatePayload = {
  __typename?: 'LotNoteUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of LotPhotoBotRequest */
export type LotPhotoBotRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lotId: Scalars['LotID'];
  lotSource: LotSource;
  lotType: LotTypeEnum;
};

/** Autogenerated return type of LotPhotoBotRequest. */
export type LotPhotoBotRequestPayload = {
  __typename?: 'LotPhotoBotRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  lot?: Maybe<Lot>;
};

/** Autogenerated input type of LotPhotoFetch */
export type LotPhotoFetchInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lotId: Scalars['LotID'];
  lotSource: LotSource;
  lotType: LotTypeEnum;
};

/** Autogenerated return type of LotPhotoFetch. */
export type LotPhotoFetchPayload = {
  __typename?: 'LotPhotoFetchPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  lot?: Maybe<Lot>;
};

/** Autogenerated input type of LotPhotoRequest */
export type LotPhotoRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lotId: Scalars['LotID'];
  lotSource: LotSource;
  lotType: LotTypeEnum;
};

/** Autogenerated return type of LotPhotoRequest. */
export type LotPhotoRequestPayload = {
  __typename?: 'LotPhotoRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  lot?: Maybe<Lot>;
};

/** Autogenerated input type of LotProductionDateCheckRequestCreate */
export type LotProductionDateCheckRequestCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lotId: Scalars['LotID'];
  lotSource: LotSource;
  lotType: LotTypeEnum;
  message?: Maybe<Scalars['SecureString']>;
  vin: Scalars['SecureString'];
};

/** Autogenerated return type of LotProductionDateCheckRequestCreate. */
export type LotProductionDateCheckRequestCreatePayload = {
  __typename?: 'LotProductionDateCheckRequestCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  userRequest?: Maybe<UserRequestUnion>;
};

/** Autogenerated input type of LotProductionDateFetch */
export type LotProductionDateFetchInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lotId: Scalars['LotID'];
  lotSource: LotSource;
  lotType: LotTypeEnum;
  vin: Scalars['SecureString'];
};

/** Autogenerated return type of LotProductionDateFetch. */
export type LotProductionDateFetchPayload = {
  __typename?: 'LotProductionDateFetchPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  lot?: Maybe<Lot>;
};

/** Autogenerated input type of LotReset */
export type LotResetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lotId: Scalars['LotID'];
  lotSource: LotSource;
  lotType: LotTypeEnum;
};

/** Autogenerated return type of LotReset. */
export type LotResetPayload = {
  __typename?: 'LotResetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  lot?: Maybe<Lot>;
};

/** Autogenerated input type of LotSettingsUpdate */
export type LotSettingsUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lotId: Scalars['LotID'];
  lotSource: LotSource;
  lotType: LotTypeEnum;
  translationsHidden: Scalars['Boolean'];
};

/** Autogenerated return type of LotSettingsUpdate. */
export type LotSettingsUpdatePayload = {
  __typename?: 'LotSettingsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  lotSetting?: Maybe<LotSetting>;
};

/** Autogenerated input type of LotTranslateRequestCreate */
export type LotTranslateRequestCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lotId: Scalars['LotID'];
  lotSource: LotSource;
  lotType: LotTypeEnum;
  message?: Maybe<Scalars['SecureString']>;
  targetLanguage: TranslationLanguage;
  translationMediaType: TranslationMediaTypeEnum;
};

/** Autogenerated return type of LotTranslateRequestCreate. */
export type LotTranslateRequestCreatePayload = {
  __typename?: 'LotTranslateRequestCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  userRequest?: Maybe<UserRequestUnion>;
};

/** Autogenerated input type of LotUpdate */
export type LotUpdateInput = {
  auctionDatetime?: Maybe<Scalars['DateTime']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  colorEn?: Maybe<Scalars['String']>;
  companyEn?: Maybe<Scalars['String']>;
  engineVolumeNum?: Maybe<Scalars['Int']>;
  icons?: Maybe<Array<LotIconEnum>>;
  lotId: Scalars['LotID'];
  lotSource: LotSource;
  lotType: LotTypeEnum;
  mileageNum?: Maybe<Scalars['Int']>;
  modelEn?: Maybe<Scalars['String']>;
  modelGradeEn?: Maybe<Scalars['String']>;
  modelTypeEn?: Maybe<Scalars['String']>;
  photos?: Maybe<Array<Scalars['String']>>;
  ratingEn?: Maybe<Scalars['String']>;
  startPriceNum?: Maybe<Scalars['Int']>;
  transmissionEn?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of LotUpdate. */
export type LotUpdatePayload = {
  __typename?: 'LotUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  lot?: Maybe<Lot>;
};

/** Autogenerated input type of NotificationSettingsUpdate */
export type NotificationSettingsUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  settings: Array<NotificationSettingInput>;
};

export type NotificationSettingInput = {
  channel: NotificationSettingChannel;
  name: NotificationSettingName;
  value: Scalars['Boolean'];
};

export enum NotificationSettingChannel {
  Email = 'email',
  Sms = 'sms',
  Telegram = 'telegram'
}

export enum NotificationSettingName {
  AkebonoBidBought = 'AkebonoBidBought',
  AkebonoBidTranslationCompleted = 'AkebonoBidTranslationCompleted',
  AkebonoBidWasOverbid = 'AkebonoBidWasOverbid'
}

/** Autogenerated return type of NotificationSettingsUpdate. */
export type NotificationSettingsUpdatePayload = {
  __typename?: 'NotificationSettingsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of PlugViewBestBidSubscriptionOnAdvanceUpdateRequestCreate */
export type PlugViewBestBidSubscriptionOnAdvanceUpdateRequestCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['SecureString']>;
};

/** Autogenerated return type of PlugViewBestBidSubscriptionOnAdvanceUpdateRequestCreate. */
export type PlugViewBestBidSubscriptionOnAdvanceUpdateRequestCreatePayload = {
  __typename?: 'PlugViewBestBidSubscriptionOnAdvanceUpdateRequestCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of PresignedPostCreate */
export type PresignedPostCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  contentType: Scalars['String'];
  filename: Scalars['String'];
};

/** Autogenerated return type of PresignedPostCreate. */
export type PresignedPostCreatePayload = {
  __typename?: 'PresignedPostCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  fields?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of ProductionDateFetch */
export type ProductionDateFetchInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  company: CompaniesEnum;
  vin: Scalars['String'];
};

export enum CompaniesEnum {
  Daihatsu = 'DAIHATSU',
  Honda = 'HONDA',
  Isuzu = 'ISUZU',
  Mazda = 'MAZDA',
  Mitsubishi = 'MITSUBISHI',
  Nissan = 'NISSAN',
  Subaru = 'SUBARU',
  Suzuki = 'SUZUKI',
  Toyota = 'TOYOTA'
}

/** Autogenerated return type of ProductionDateFetch. */
export type ProductionDateFetchPayload = {
  __typename?: 'ProductionDateFetchPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSON']>;
  error?: Maybe<Error>;
  productionDate?: Maybe<Scalars['String']>;
  productionDateGte?: Maybe<Scalars['String']>;
  productionDateLte?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of TranslationFeedbackCreate */
export type TranslationFeedbackCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  feedbackType: TranslationFeedbackTypeEnum;
  message?: Maybe<Scalars['String']>;
  translationId: Scalars['String'];
};

/** Autogenerated return type of TranslationFeedbackCreate. */
export type TranslationFeedbackCreatePayload = {
  __typename?: 'TranslationFeedbackCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  translationFeedback?: Maybe<TranslationFeedback>;
};

/** Autogenerated input type of TranslationFeedbackDelete */
export type TranslationFeedbackDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

/** Autogenerated return type of TranslationFeedbackDelete. */
export type TranslationFeedbackDeletePayload = {
  __typename?: 'TranslationFeedbackDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of TranslationFeedbackUpdate */
export type TranslationFeedbackUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  feedbackType: TranslationFeedbackTypeEnum;
  id: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of TranslationFeedbackUpdate. */
export type TranslationFeedbackUpdatePayload = {
  __typename?: 'TranslationFeedbackUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  translationFeedback?: Maybe<TranslationFeedback>;
};

/** Autogenerated input type of UserChannelCreate */
export type UserChannelCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Scalars['String']>>;
  path: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

/** Autogenerated return type of UserChannelCreate. */
export type UserChannelCreatePayload = {
  __typename?: 'UserChannelCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of UserChannelDelete */
export type UserChannelDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of UserChannelDelete. */
export type UserChannelDeletePayload = {
  __typename?: 'UserChannelDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of UserChannelUpdate */
export type UserChannelUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Scalars['String']>>;
  path: Scalars['String'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

/** Autogenerated return type of UserChannelUpdate. */
export type UserChannelUpdatePayload = {
  __typename?: 'UserChannelUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of UserFilterPresetCreate */
export type UserFilterPresetCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  compilationEmailEnabled: Scalars['Boolean'];
  content: Scalars['JSON'];
  title: Scalars['String'];
};

/** Autogenerated return type of UserFilterPresetCreate. */
export type UserFilterPresetCreatePayload = {
  __typename?: 'UserFilterPresetCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of UserFilterPresetDelete */
export type UserFilterPresetDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of UserFilterPresetDelete. */
export type UserFilterPresetDeletePayload = {
  __typename?: 'UserFilterPresetDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of UserFilterPresetUpdate */
export type UserFilterPresetUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  compilationEmailEnabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of UserFilterPresetUpdate. */
export type UserFilterPresetUpdatePayload = {
  __typename?: 'UserFilterPresetUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of UserLotMarkCreate */
export type UserLotMarkCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  lotId: Scalars['LotID'];
  lotSource: LotSource;
  lotType: LotTypeEnum;
  mark: UserLotMarkEnum;
  userLotMarksListId?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of UserLotMarkCreate. */
export type UserLotMarkCreatePayload = {
  __typename?: 'UserLotMarkCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  userLotMark?: Maybe<UserLotMark>;
};

/** Autogenerated input type of UserLotMarkDelete */
export type UserLotMarkDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of UserLotMarkDelete. */
export type UserLotMarkDeletePayload = {
  __typename?: 'UserLotMarkDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  userLotMark?: Maybe<UserLotMark>;
};

/** Autogenerated input type of UserLotMarksListClear */
export type UserLotMarksListClearInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of UserLotMarksListClear. */
export type UserLotMarksListClearPayload = {
  __typename?: 'UserLotMarksListClearPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of UserLotMarksListCreate */
export type UserLotMarksListCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  publishedAt: Scalars['DateTime'];
  title: Scalars['String'];
};

/** Autogenerated return type of UserLotMarksListCreate. */
export type UserLotMarksListCreatePayload = {
  __typename?: 'UserLotMarksListCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  userLotMarksListId: Scalars['ID'];
};

/** Autogenerated input type of UserLotMarksListDelete */
export type UserLotMarksListDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** Autogenerated return type of UserLotMarksListDelete. */
export type UserLotMarksListDeletePayload = {
  __typename?: 'UserLotMarksListDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of UserLotMarksListFill */
export type UserLotMarksListFillInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  userLotMarkIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of UserLotMarksListFill. */
export type UserLotMarksListFillPayload = {
  __typename?: 'UserLotMarksListFillPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of UserLotMarksListUpdate */
export type UserLotMarksListUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  path?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of UserLotMarksListUpdate. */
export type UserLotMarksListUpdatePayload = {
  __typename?: 'UserLotMarksListUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of UserLotMarksUpdate */
export type UserLotMarksUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  ids?: Maybe<Array<Scalars['ID']>>;
  mark: UserLotMarkEnum;
  userLotMarksListId?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of UserLotMarksUpdate. */
export type UserLotMarksUpdatePayload = {
  __typename?: 'UserLotMarksUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  userLotMarks?: Maybe<Array<UserLotMark>>;
};

/** Autogenerated input type of UserLotMarkUpdate */
export type UserLotMarkUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  mark: UserLotMarkEnum;
  userLotMarksListId?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of UserLotMarkUpdate. */
export type UserLotMarkUpdatePayload = {
  __typename?: 'UserLotMarkUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  userLotMark?: Maybe<UserLotMark>;
};

/** Autogenerated input type of UserUpdate */
export type UserUpdateInput = {
  bidTranslationByDefault?: Maybe<Scalars['Boolean']>;
  birthdate?: Maybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  countryIso?: Maybe<Scalars['String']>;
  defaultTranslationMediaType?: Maybe<TranslationMediaTypeEnum>;
  ignoreSmallBidWarning?: Maybe<Scalars['Boolean']>;
  preferredLang?: Maybe<PreferredLang>;
};

/** Autogenerated return type of UserUpdate. */
export type UserUpdatePayload = {
  __typename?: 'UserUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

/** Autogenerated input type of UserViewBestBidSubscribe */
export type UserViewBestBidSubscribeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  plugWhenAdvanceUpdate: Scalars['Boolean'];
};

/** Autogenerated return type of UserViewBestBidSubscribe. */
export type UserViewBestBidSubscribePayload = {
  __typename?: 'UserViewBestBidSubscribePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
};

export type AlertFragment = { __typename?: 'Alert', id?: Maybe<string>, style?: Maybe<AlertStyleEnum>, target?: Maybe<AlertTargetEnum>, contentEn?: Maybe<string>, contentRu?: Maybe<string>, isOnetime?: Maybe<boolean>, countryIso?: Maybe<string> };

export type AuctionSheetZoneFragment = { __typename?: 'AuctionSheetZone', id?: Maybe<string>, code?: Maybe<string>, zoneType?: Maybe<AuctionSheetZoneTypeEnum>, x?: Maybe<number>, y?: Maybe<number>, w?: Maybe<number>, h?: Maybe<number> };

export type BidAmountFragment = { __typename?: 'Bid', id?: Maybe<string>, amount?: Maybe<number>, commission?: Maybe<number>, fullAmount?: Maybe<number> };

export type BidCommentsFragment = { __typename?: 'Bid', comments?: Maybe<Array<{ __typename?: 'BidComment', id?: Maybe<string>, content?: Maybe<string>, isManager?: Maybe<boolean>, createdAt?: Maybe<any>, user?: Maybe<{ __typename?: 'UserInfo', id?: Maybe<string>, username?: Maybe<string>, fullName?: Maybe<string> }> }>> };

export type CurrentTradingTimeShiftFragment = { __typename?: 'AuctionTradingTimeShift', auctionDate?: Maybe<string>, codeFrom?: Maybe<any>, codeTo?: Maybe<any>, id?: Maybe<string>, shiftInSeconds?: Maybe<number>, speedUp?: Maybe<boolean> };

export type ImportedLotFragment = { __typename?: 'Lot', id?: Maybe<any>, code?: Maybe<string>, link?: Maybe<string>, year?: Maybe<string>, images?: Maybe<Array<string>>, modelEn?: Maybe<string>, companyEn?: Maybe<string>, subgroup?: Maybe<LotTypeEnum>, modelTypeEn?: Maybe<string>, auctionName?: Maybe<string>, auctionDate?: Maybe<any>, auctionDatetime?: Maybe<any>, modelGradeEn?: Maybe<string>, transmissionEn?: Maybe<string>, engineVolumeNum?: Maybe<number>, colorEn?: Maybe<string>, ratingEn?: Maybe<string>, mileageNum?: Maybe<string>, startPriceNum?: Maybe<string>, soldPrice?: Maybe<any>, currentUserLotBidsLimitReached?: Maybe<boolean> };

export type LotCountersFragment = { __typename?: 'Lot', id?: Maybe<any>, bidsCount?: Maybe<number>, biddersCount?: Maybe<number>, viewsCount?: Maybe<number>, inFavoritesCount?: Maybe<number> };

export type LotDataFragment = { __typename?: 'Lot', id?: Maybe<any>, soldPrice?: Maybe<any>, bidsCount?: Maybe<number>, biddersCount?: Maybe<number>, viewsCount?: Maybe<number>, inFavoritesCount?: Maybe<number>, currentUserLotMarks?: Maybe<Array<{ __typename?: 'UserLotMark', id?: Maybe<string>, mark?: Maybe<UserLotMarkEnum>, viewsCount?: Maybe<number>, userLotMarksListTitle?: Maybe<string>, lot?: Maybe<{ __typename?: 'Lot', id?: Maybe<any> }> }>>, currentUserLastBid?: Maybe<{ __typename?: 'Bid', id?: Maybe<string>, status?: Maybe<BidStatusEnum> }>, currentUserLastLotSourceView?: Maybe<{ __typename?: 'LotSourceView', id?: Maybe<string> }> };

export type LotTranslationFragment = { __typename?: 'LotTranslation', id?: Maybe<string>, language?: Maybe<string>, message?: Maybe<string>, aiModel?: Maybe<string>, aiProvider?: Maybe<string>, likesCount?: Maybe<number>, dislikesCount?: Maybe<number>, translatorId?: Maybe<string>, currentUserTranslationFeedback?: Maybe<{ __typename?: 'TranslationFeedback', akebonoLotTranslationId?: Maybe<string>, feedbackType?: Maybe<TranslationFeedbackTypeEnum>, id?: Maybe<string>, userId?: Maybe<string>, message?: Maybe<string> }>, file?: Maybe<{ __typename?: 'S3File', filename?: Maybe<string>, fullPath?: Maybe<string>, id?: Maybe<string>, key?: Maybe<string> }> };

export type LotVersionsFragment = { __typename?: 'Lot', id?: Maybe<any>, code?: Maybe<string>, modelEn?: Maybe<string>, colorEn?: Maybe<string>, companyEn?: Maybe<string>, auctionName?: Maybe<string>, versions?: Maybe<Array<{ __typename?: 'TrailEvent', changeset?: Maybe<any>, versionNumber?: Maybe<number>, createdAt?: Maybe<any>, author?: Maybe<{ __typename?: 'TrailEventAuthor', id?: Maybe<string>, fullName?: Maybe<string>, username?: Maybe<string>, countryIso?: Maybe<string> }> }>> };

export type LotViewsCountFragment = { __typename?: 'LotViewsCount', originalId: any, viewsCount: number };

export type LotViewsFragment = { __typename?: 'Lot', lotSourceViews?: Maybe<Array<{ __typename?: 'LotSourceView', id?: Maybe<string>, createdAt: any, user: { __typename?: 'UserInfo', id?: Maybe<string>, username?: Maybe<string>, fullName?: Maybe<string> } }>>, currentUserLastLotSourceView?: Maybe<{ __typename?: 'LotSourceView', id?: Maybe<string>, updatedAt: any }> };

export type UniversalLotTableFragment = { __typename?: 'Lot', id?: Maybe<any>, code?: Maybe<string>, link?: Maybe<string>, auctionName?: Maybe<string>, auctionDatetime?: Maybe<any>, colorEn?: Maybe<string>, companyEn?: Maybe<string>, modelEn?: Maybe<string>, year?: Maybe<string>, status?: Maybe<LotStatusEnum>, transmissionEn?: Maybe<string>, images?: Maybe<Array<string>>, thumbnails?: Maybe<Array<string>>, startPriceNum?: Maybe<string>, endPriceNum?: Maybe<string>, engineVolumeNum?: Maybe<number>, mileageNum?: Maybe<string>, modelDetailsEn?: Maybe<string>, modelGradeEn?: Maybe<string>, modelTypeEn?: Maybe<string>, modelYearEn?: Maybe<string> };

export type UserBidSettingsFragment = { __typename?: 'CurrentUser', id?: Maybe<string>, hideBidAmount?: Maybe<boolean>, bidTranslationByDefault?: Maybe<boolean>, ignoreSmallBidWarning?: Maybe<boolean>, isOtherCountries?: Maybe<boolean>, canSeeBestBid?: Maybe<boolean>, canSeeBestBidAdmin?: Maybe<boolean>, bestBidViewServiceSubscription?: Maybe<{ __typename?: 'ServiceSubscription', id?: Maybe<string>, expiresAt?: Maybe<any> }> };

export type UserLotMarkDataFragment = { __typename?: 'UserLotMark', id?: Maybe<string>, mark?: Maybe<UserLotMarkEnum>, lot?: Maybe<{ __typename?: 'Lot', id?: Maybe<any>, subgroup?: Maybe<LotTypeEnum> }> };

export type UserLotMarkFragment = { __typename?: 'UserLotMark', id?: Maybe<string>, mark?: Maybe<UserLotMarkEnum>, viewsCount?: Maybe<number>, userLotMarksListTitle?: Maybe<string>, lot?: Maybe<{ __typename?: 'Lot', id?: Maybe<any> }> };

export type UserNotificationSettingsFragment = { __typename?: 'CurrentUser', id?: Maybe<string>, notificationSettings?: Maybe<any> };

export type CurrentUserTranslationFeedbackFragment = { __typename?: 'TranslationFeedback', akebonoLotTranslationId?: Maybe<string>, feedbackType?: Maybe<TranslationFeedbackTypeEnum>, id?: Maybe<string>, userId?: Maybe<string>, message?: Maybe<string> };

export type UserTranslationSettingsFragment = { __typename?: 'CurrentUser', id?: Maybe<string>, preferredLang?: Maybe<PreferredLang>, countryIso?: Maybe<string>, defaultTranslationMediaType?: Maybe<TranslationMediaTypeEnum> };

export type UserViewBestBidSubscriptionDataFragment = { __typename?: 'CurrentUser', id?: Maybe<string>, canSeeBestBid?: Maybe<boolean>, canSeeBestBidAdmin?: Maybe<boolean>, bestBidViewServiceSubscription?: Maybe<{ __typename?: 'ServiceSubscription', id?: Maybe<string>, expiresAt?: Maybe<any> }> };

export type BidCommentCreateMutationVariables = Exact<{
  input: BidCommentCreateInput;
}>;


export type BidCommentCreateMutation = { __typename?: 'Mutation', bidCommentCreate?: Maybe<{ __typename?: 'BidCommentCreatePayload', error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type BidCreateManualMutationVariables = Exact<{
  input: BidCreateManualInput;
}>;


export type BidCreateManualMutation = { __typename?: 'Mutation', bidCreateManual?: Maybe<{ __typename?: 'BidCreateManualPayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', backtrace?: Maybe<string>, code?: Maybe<string>, message?: Maybe<string> }> }> };

export type BidCreateMutationVariables = Exact<{
  input: BidCreateInput;
}>;


export type BidCreateMutation = { __typename?: 'Mutation', bidCreate?: Maybe<{ __typename?: 'BidCreatePayload', clientMutationId?: Maybe<string>, hint?: Maybe<{ __typename?: 'PlaceBidHint', text?: Maybe<string>, triesLeft?: Maybe<number> }>, error?: Maybe<{ __typename?: 'Error', backtrace?: Maybe<string>, code?: Maybe<string>, message?: Maybe<string> }> }> };

export type BidDeleteRequestCreateMutationVariables = Exact<{
  input: BidDeleteRequestCreateInput;
}>;


export type BidDeleteRequestCreateMutation = { __typename?: 'Mutation', bidDeleteRequestCreate?: Maybe<{ __typename?: 'BidDeleteRequestCreatePayload', error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type BidGroupCreateMutationVariables = Exact<{
  input: BidGroupCreateInput;
}>;


export type BidGroupCreateMutation = { __typename?: 'Mutation', bidGroupCreate?: Maybe<{ __typename?: 'BidGroupCreatePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', backtrace?: Maybe<string>, code?: Maybe<string>, message?: Maybe<string> }>, group?: Maybe<{ __typename?: 'BidGroup', id?: Maybe<string>, letter: string, quantity: string, date: any, bidsLimitReached: boolean, lotsLimitReached: boolean }> }> };

export type BidUpdateMutationVariables = Exact<{
  input: BidUpdateInput;
}>;


export type BidUpdateMutation = { __typename?: 'Mutation', bidUpdate?: Maybe<{ __typename?: 'BidUpdatePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', backtrace?: Maybe<string>, code?: Maybe<string>, message?: Maybe<string> }>, bid?: Maybe<{ __typename?: 'Bid', id?: Maybe<string>, isNegotiationsAccepted?: Maybe<boolean>, isParticipationAccepted?: Maybe<boolean> }> }> };

export type GuidanceRequestCreateMutationVariables = Exact<{
  input: GuidanceRequestCreateInput;
}>;


export type GuidanceRequestCreateMutation = { __typename?: 'Mutation', guidanceRequestCreate?: Maybe<{ __typename?: 'GuidanceRequestCreatePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type LotAiTranslationCreateMutationVariables = Exact<{
  input: LotAiTranslationCreateInput;
}>;


export type LotAiTranslationCreateMutation = { __typename?: 'Mutation', lotAiTranslationCreate?: Maybe<{ __typename?: 'LotAiTranslationCreatePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type LotAraiKenkiPhotoFetchMutationVariables = Exact<{
  input: LotAraiKenkiPhotoFetchInput;
}>;


export type LotAraiKenkiPhotoFetchMutation = { __typename?: 'Mutation', lotAraiKenkiPhotoFetch?: Maybe<{ __typename?: 'LotAraiKenkiPhotoFetchPayload', error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type LotAutoTranslationCreateMutationVariables = Exact<{
  input: LotAutoTranslationCreateInput;
}>;


export type LotAutoTranslationCreateMutation = { __typename?: 'Mutation', lotAutoTranslationCreate?: Maybe<{ __typename?: 'LotAutoTranslationCreatePayload', error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type LotCreateManualMutationVariables = Exact<{
  input: LotCreateManualInput;
}>;


export type LotCreateManualMutation = { __typename?: 'Mutation', lotCreateManual?: Maybe<{ __typename?: 'LotCreateManualPayload', error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type LotIncrementViewsCountMutationVariables = Exact<{
  input: LotIncrementViewsCountInput;
}>;


export type LotIncrementViewsCountMutation = { __typename?: 'Mutation', lotIncrementViewsCount?: Maybe<{ __typename?: 'LotIncrementViewsCountPayload', error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type LotNegotiationsOpenMutationVariables = Exact<{
  input: LotNegotiationsOpenInput;
}>;


export type LotNegotiationsOpenMutation = { __typename?: 'Mutation', lotNegotiationsOpen?: Maybe<{ __typename?: 'LotNegotiationsOpenPayload', lot?: Maybe<{ __typename?: 'Lot', id?: Maybe<any>, status?: Maybe<LotStatusEnum>, negotiationsPrice?: Maybe<any>, canOpenNegotiations?: Maybe<boolean>, canEditNegotiationsPrice?: Maybe<boolean>, negotiationsAvailable?: Maybe<boolean>, negotiationsEndsAt?: Maybe<any>, tradingClosed?: Maybe<boolean>, tradingClosureBiddingEndsAt?: Maybe<any> }>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type LotNoteCreateMutationVariables = Exact<{
  input: LotNoteCreateInput;
}>;


export type LotNoteCreateMutation = { __typename?: 'Mutation', lotNoteCreate?: Maybe<{ __typename?: 'LotNoteCreatePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type LotNoteDeleteMutationVariables = Exact<{
  input: LotNoteDeleteInput;
}>;


export type LotNoteDeleteMutation = { __typename?: 'Mutation', lotNoteDelete?: Maybe<{ __typename?: 'LotNoteDeletePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type LotNoteUpdateMutationVariables = Exact<{
  input: LotNoteUpdateInput;
}>;


export type LotNoteUpdateMutation = { __typename?: 'Mutation', lotNoteUpdate?: Maybe<{ __typename?: 'LotNoteUpdatePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type LotPhotoFetchMutationVariables = Exact<{
  input: LotPhotoFetchInput;
}>;


export type LotPhotoFetchMutation = { __typename?: 'Mutation', lotPhotoFetch?: Maybe<{ __typename?: 'LotPhotoFetchPayload', lot?: Maybe<{ __typename?: 'Lot', id?: Maybe<any>, images?: Maybe<Array<string>>, thumbnails?: Maybe<Array<string>> }>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type LotPhotoRequestMutationVariables = Exact<{
  input: LotPhotoRequestInput;
}>;


export type LotPhotoRequestMutation = { __typename?: 'Mutation', lotPhotoRequest?: Maybe<{ __typename?: 'LotPhotoRequestPayload', error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type LotProductionDateCheckRequestCreateMutationVariables = Exact<{
  input: LotProductionDateCheckRequestCreateInput;
}>;


export type LotProductionDateCheckRequestCreateMutation = { __typename?: 'Mutation', lotProductionDateCheckRequestCreate?: Maybe<{ __typename?: 'LotProductionDateCheckRequestCreatePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type LotProductionDateFetchMutationVariables = Exact<{
  input: LotProductionDateFetchInput;
}>;


export type LotProductionDateFetchMutation = { __typename?: 'Mutation', lotProductionDateFetch?: Maybe<{ __typename?: 'LotProductionDateFetchPayload', lot?: Maybe<{ __typename?: 'Lot', id?: Maybe<any>, vin?: Maybe<string>, productionDate?: Maybe<any>, productionDatePayload?: Maybe<any>, kawasakiLotData?: Maybe<any> }>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type LotResetMutationVariables = Exact<{
  input: LotResetInput;
}>;


export type LotResetMutation = { __typename?: 'Mutation', lotReset?: Maybe<{ __typename?: 'LotResetPayload', error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type LotSettingsUpdateMutationVariables = Exact<{
  input: LotSettingsUpdateInput;
}>;


export type LotSettingsUpdateMutation = { __typename?: 'Mutation', lotSettingsUpdate?: Maybe<{ __typename?: 'LotSettingsUpdatePayload', error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type LotTranslateRequestCreateMutationVariables = Exact<{
  input: LotTranslateRequestCreateInput;
}>;


export type LotTranslateRequestCreateMutation = { __typename?: 'Mutation', lotTranslateRequestCreate?: Maybe<{ __typename?: 'LotTranslateRequestCreatePayload', error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type LotUpdateMutationVariables = Exact<{
  input: LotUpdateInput;
}>;


export type LotUpdateMutation = { __typename?: 'Mutation', lotUpdate?: Maybe<{ __typename?: 'LotUpdatePayload', lot?: Maybe<{ __typename?: 'Lot', id?: Maybe<any>, icons?: Maybe<Array<LotIconEnum>>, images?: Maybe<Array<string>>, thumbnails?: Maybe<Array<string>> }>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type LotPhotoBotRequestMutationVariables = Exact<{
  input: LotPhotoBotRequestInput;
}>;


export type LotPhotoBotRequestMutation = { __typename?: 'Mutation', lotPhotoBotRequest?: Maybe<{ __typename?: 'LotPhotoBotRequestPayload', error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type NotificationSettingsUpdateMutationVariables = Exact<{
  input: NotificationSettingsUpdateInput;
}>;


export type NotificationSettingsUpdateMutation = { __typename?: 'Mutation', notificationSettingsUpdate?: Maybe<{ __typename?: 'NotificationSettingsUpdatePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type PlugViewBestBidSubscriptionOnAdvanceUpdateRequestCreateMutationVariables = Exact<{
  input: PlugViewBestBidSubscriptionOnAdvanceUpdateRequestCreateInput;
}>;


export type PlugViewBestBidSubscriptionOnAdvanceUpdateRequestCreateMutation = { __typename?: 'Mutation', plugViewBestBidSubscriptionOnAdvanceUpdateRequestCreate?: Maybe<{ __typename?: 'PlugViewBestBidSubscriptionOnAdvanceUpdateRequestCreatePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type PresignedPostCreateMutationVariables = Exact<{
  input: PresignedPostCreateInput;
}>;


export type PresignedPostCreateMutation = { __typename?: 'Mutation', presignedPostCreate?: Maybe<{ __typename?: 'PresignedPostCreatePayload', clientMutationId?: Maybe<string>, fields?: Maybe<string>, url?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type ProductionDateFetchMutationVariables = Exact<{
  input: ProductionDateFetchInput;
}>;


export type ProductionDateFetchMutation = { __typename?: 'Mutation', productionDateFetch?: Maybe<{ __typename?: 'ProductionDateFetchPayload', clientMutationId?: Maybe<string>, data?: Maybe<any>, productionDate?: Maybe<string>, productionDateGte?: Maybe<string>, productionDateLte?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', backtrace?: Maybe<string>, code?: Maybe<string>, message?: Maybe<string> }> }> };

export type TranslationFeedbackCreateMutationVariables = Exact<{
  input: TranslationFeedbackCreateInput;
}>;


export type TranslationFeedbackCreateMutation = { __typename?: 'Mutation', translationFeedbackCreate?: Maybe<{ __typename?: 'TranslationFeedbackCreatePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type TranslationFeedbackDeleteMutationVariables = Exact<{
  input: TranslationFeedbackDeleteInput;
}>;


export type TranslationFeedbackDeleteMutation = { __typename?: 'Mutation', translationFeedbackDelete?: Maybe<{ __typename?: 'TranslationFeedbackDeletePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type TranslationFeedbackUpdateMutationVariables = Exact<{
  input: TranslationFeedbackUpdateInput;
}>;


export type TranslationFeedbackUpdateMutation = { __typename?: 'Mutation', translationFeedbackUpdate?: Maybe<{ __typename?: 'TranslationFeedbackUpdatePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type UserChannelCreateMutationVariables = Exact<{
  input: UserChannelCreateInput;
}>;


export type UserChannelCreateMutation = { __typename?: 'Mutation', userChannelCreate?: Maybe<{ __typename?: 'UserChannelCreatePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type UserChannelDeleteMutationVariables = Exact<{
  input: UserChannelDeleteInput;
}>;


export type UserChannelDeleteMutation = { __typename?: 'Mutation', userChannelDelete?: Maybe<{ __typename?: 'UserChannelDeletePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type UserChannelUpdateMutationVariables = Exact<{
  input: UserChannelUpdateInput;
}>;


export type UserChannelUpdateMutation = { __typename?: 'Mutation', userChannelUpdate?: Maybe<{ __typename?: 'UserChannelUpdatePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type UserFilterPresetCreateMutationVariables = Exact<{
  input: UserFilterPresetCreateInput;
}>;


export type UserFilterPresetCreateMutation = { __typename?: 'Mutation', userFilterPresetCreate?: Maybe<{ __typename?: 'UserFilterPresetCreatePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type UserFilterPresetDeleteMutationVariables = Exact<{
  input: UserFilterPresetDeleteInput;
}>;


export type UserFilterPresetDeleteMutation = { __typename?: 'Mutation', userFilterPresetDelete?: Maybe<{ __typename?: 'UserFilterPresetDeletePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type UserFilterPresetUpdateMutationVariables = Exact<{
  input: UserFilterPresetUpdateInput;
}>;


export type UserFilterPresetUpdateMutation = { __typename?: 'Mutation', userFilterPresetUpdate?: Maybe<{ __typename?: 'UserFilterPresetUpdatePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type UserLotMarkCreateMutationVariables = Exact<{
  input: UserLotMarkCreateInput;
}>;


export type UserLotMarkCreateMutation = { __typename?: 'Mutation', userLotMarkCreate?: Maybe<{ __typename?: 'UserLotMarkCreatePayload', clientMutationId?: Maybe<string>, userLotMark?: Maybe<{ __typename?: 'UserLotMark', id?: Maybe<string>, mark?: Maybe<UserLotMarkEnum>, lot?: Maybe<{ __typename?: 'Lot', id?: Maybe<any>, subgroup?: Maybe<LotTypeEnum> }> }>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type UserLotMarkDeleteMutationVariables = Exact<{
  input: UserLotMarkDeleteInput;
}>;


export type UserLotMarkDeleteMutation = { __typename?: 'Mutation', userLotMarkDelete?: Maybe<{ __typename?: 'UserLotMarkDeletePayload', clientMutationId?: Maybe<string>, userLotMark?: Maybe<{ __typename?: 'UserLotMark', id?: Maybe<string>, mark?: Maybe<UserLotMarkEnum>, lot?: Maybe<{ __typename?: 'Lot', id?: Maybe<any>, subgroup?: Maybe<LotTypeEnum> }> }>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type UserLotMarkUpdateMutationVariables = Exact<{
  input: UserLotMarkUpdateInput;
}>;


export type UserLotMarkUpdateMutation = { __typename?: 'Mutation', userLotMarkUpdate?: Maybe<{ __typename?: 'UserLotMarkUpdatePayload', clientMutationId?: Maybe<string>, userLotMark?: Maybe<{ __typename?: 'UserLotMark', id?: Maybe<string>, mark?: Maybe<UserLotMarkEnum>, lot?: Maybe<{ __typename?: 'Lot', id?: Maybe<any>, subgroup?: Maybe<LotTypeEnum> }> }>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type UserLotMarksListClearMutationVariables = Exact<{
  input: UserLotMarksListClearInput;
}>;


export type UserLotMarksListClearMutation = { __typename?: 'Mutation', userLotMarksListClear?: Maybe<{ __typename?: 'UserLotMarksListClearPayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type UserLotMarksListCreateMutationVariables = Exact<{
  input: UserLotMarksListCreateInput;
}>;


export type UserLotMarksListCreateMutation = { __typename?: 'Mutation', userLotMarksListCreate?: Maybe<{ __typename?: 'UserLotMarksListCreatePayload', clientMutationId?: Maybe<string>, userLotMarksListId: string, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type UserLotMarksListDeleteMutationVariables = Exact<{
  input: UserLotMarksListDeleteInput;
}>;


export type UserLotMarksListDeleteMutation = { __typename?: 'Mutation', userLotMarksListDelete?: Maybe<{ __typename?: 'UserLotMarksListDeletePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type UserLotMarksListUpdateMutationVariables = Exact<{
  input: UserLotMarksListUpdateInput;
}>;


export type UserLotMarksListUpdateMutation = { __typename?: 'Mutation', userLotMarksListUpdate?: Maybe<{ __typename?: 'UserLotMarksListUpdatePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type UserLotMarksUpdateMutationVariables = Exact<{
  input: UserLotMarksUpdateInput;
}>;


export type UserLotMarksUpdateMutation = { __typename?: 'Mutation', userLotMarksUpdate?: Maybe<{ __typename?: 'UserLotMarksUpdatePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type UserUpdateMutationVariables = Exact<{
  input: UserUpdateInput;
}>;


export type UserUpdateMutation = { __typename?: 'Mutation', userUpdate?: Maybe<{ __typename?: 'UserUpdatePayload', clientMutationId?: Maybe<string>, error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type UserViewBestBidSubscribeMutationVariables = Exact<{
  input: UserViewBestBidSubscribeInput;
}>;


export type UserViewBestBidSubscribeMutation = { __typename?: 'Mutation', userViewBestBidSubscribe?: Maybe<{ __typename?: 'UserViewBestBidSubscribePayload', error?: Maybe<{ __typename?: 'Error', code?: Maybe<string>, message?: Maybe<string> }> }> };

export type AlertsQueryVariables = Exact<{
  auctionId?: Maybe<Scalars['ID']>;
  target?: Maybe<AlertTargetEnum>;
  lotCode?: Maybe<Scalars['Int']>;
  isSanctioned?: Maybe<Scalars['Boolean']>;
  countryIso?: Maybe<Scalars['String']>;
  catalogCompanyTitle?: Maybe<Scalars['String']>;
  catalogModelTitle?: Maybe<Scalars['String']>;
  catalogFrameCode?: Maybe<Scalars['String']>;
}>;


export type AlertsQuery = { __typename?: 'Query', globalAlerts?: Maybe<Array<{ __typename?: 'Alert', id?: Maybe<string>, style?: Maybe<AlertStyleEnum>, target?: Maybe<AlertTargetEnum>, contentEn?: Maybe<string>, contentRu?: Maybe<string>, isOnetime?: Maybe<boolean>, countryIso?: Maybe<string> }>>, countryAlerts?: Maybe<Array<{ __typename?: 'Alert', id?: Maybe<string>, style?: Maybe<AlertStyleEnum>, target?: Maybe<AlertTargetEnum>, contentEn?: Maybe<string>, contentRu?: Maybe<string>, isOnetime?: Maybe<boolean>, countryIso?: Maybe<string> }>> };

export type ApplicationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ApplicationSettingsQuery = { __typename?: 'Query', applicationSettings?: Maybe<{ __typename?: 'ApplicationSetting', aiTranslationGenerationEnabled?: Maybe<boolean> }> };

export type AuctionAliasesQueryVariables = Exact<{ [key: string]: never; }>;


export type AuctionAliasesQuery = { __typename?: 'Query', auctions: Array<{ __typename?: 'Auction', id?: Maybe<string>, title?: Maybe<string>, cartrackAuctionId?: Maybe<string>, auctionAliases?: Maybe<Array<{ __typename?: 'Auction', id?: Maybe<string>, title?: Maybe<string> }>>, auctionSheetZones?: Maybe<Array<{ __typename?: 'AuctionSheetZone', id?: Maybe<string>, code?: Maybe<string>, zoneType?: Maybe<AuctionSheetZoneTypeEnum>, x?: Maybe<number>, y?: Maybe<number>, w?: Maybe<number>, h?: Maybe<number> }>>, auctionDescription?: Maybe<{ __typename?: 'AuctionDescription', aiTranslationEnabled?: Maybe<boolean>, id?: Maybe<string> }>, currentTradingTimeShifts?: Maybe<Array<{ __typename?: 'AuctionTradingTimeShift', auctionDate?: Maybe<string>, codeFrom?: Maybe<any>, codeTo?: Maybe<any>, id?: Maybe<string>, shiftInSeconds?: Maybe<number>, speedUp?: Maybe<boolean> }>> }> };

export type BidAmountRecommendationQueryVariables = Exact<{
  companyEn: Scalars['String'];
  modelEn: Scalars['String'];
  modelTypeEn: Scalars['String'];
  year: Scalars['Int'];
  ratingEn: Scalars['String'];
  mileage: Scalars['Int'];
  noOfDays?: Maybe<Scalars['Int']>;
}>;


export type BidAmountRecommendationQuery = { __typename?: 'Query', weightedHarmonicMean?: Maybe<number> };

export type BidAmountScoreQueryVariables = Exact<{
  amount: Scalars['Int'];
  companyEn: Scalars['String'];
  modelEn: Scalars['String'];
  modelTypeEn: Scalars['String'];
  year: Scalars['Int'];
  ratingEn: Scalars['String'];
  mileage: Scalars['Int'];
}>;


export type BidAmountScoreQuery = { __typename?: 'Query', bidScore?: Maybe<number> };

export type BidDataQueryVariables = Exact<{
  date: Scalars['DateTime'];
  lotType: LotTypeEnum;
  auctionId?: Maybe<Scalars['ID']>;
}>;


export type BidDataQuery = { __typename?: 'Query', maxBidAmount?: Maybe<number>, minBidCommission?: Maybe<number>, currentUser?: Maybe<{ __typename?: 'CurrentUser', id?: Maybe<string>, birthdate?: Maybe<string>, countryIso?: Maybe<string>, isOtherCountries?: Maybe<boolean>, maxBidAmountLimit?: Maybe<number>, ignoreSmallBidWarning?: Maybe<boolean>, bidTranslationByDefault?: Maybe<boolean>, defaultBidConditionId?: Maybe<string>, isManager?: Maybe<boolean>, bidGroups?: Maybe<{ __typename?: 'BidGroupPaginatedList', total: number, nodes: Array<{ __typename?: 'BidGroup', id?: Maybe<string>, letter: string, quantity: string, date: any, bidsLimitReached: boolean, lotsLimitReached: boolean }> }>, officeBranch?: Maybe<{ __typename?: 'OfficeBranch', id?: Maybe<string>, code?: Maybe<string>, title?: Maybe<string>, isWorldwide?: Maybe<boolean> }> }>, bidConditions: Array<{ __typename?: 'BidCondition', id?: Maybe<string>, title?: Maybe<string>, isAuto?: Maybe<boolean>, isMoto?: Maybe<boolean>, isOnePrice?: Maybe<boolean>, isDisassembly?: Maybe<boolean>, minYear?: Maybe<number> }>, alerts?: Maybe<Array<{ __typename?: 'Alert', id?: Maybe<string>, style?: Maybe<AlertStyleEnum>, target?: Maybe<AlertTargetEnum>, contentEn?: Maybe<string>, contentRu?: Maybe<string>, isOnetime?: Maybe<boolean>, countryIso?: Maybe<string> }>>, sanctionedAlerts?: Maybe<Array<{ __typename?: 'Alert', id?: Maybe<string>, style?: Maybe<AlertStyleEnum>, target?: Maybe<AlertTargetEnum>, contentEn?: Maybe<string>, contentRu?: Maybe<string>, isOnetime?: Maybe<boolean>, countryIso?: Maybe<string> }>> };

export type BidManualDataQueryVariables = Exact<{
  withUnassignedCartrackAuction?: Maybe<Scalars['Boolean']>;
}>;


export type BidManualDataQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'CurrentUser', id?: Maybe<string>, isOtherCountries?: Maybe<boolean>, isManager?: Maybe<boolean>, officeBranch?: Maybe<{ __typename?: 'OfficeBranch', id?: Maybe<string>, code?: Maybe<string>, title?: Maybe<string>, isWorldwide?: Maybe<boolean> }> }>, bidConditions: Array<{ __typename?: 'BidCondition', id?: Maybe<string>, title?: Maybe<string>, isAuto?: Maybe<boolean>, isMoto?: Maybe<boolean>, isOnePrice?: Maybe<boolean>, isDisassembly?: Maybe<boolean>, minYear?: Maybe<number> }>, auctions: Array<{ __typename?: 'Auction', id?: Maybe<string>, title?: Maybe<string> }> };

export type BidsQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  filter?: Maybe<AutoCurrentUserBidsFilter>;
  sort?: Maybe<AutoCurrentUserBidsSort>;
  bidLotAuctionDateFrom?: Maybe<Scalars['DateTime']>;
  bidLotAuctionDateTo?: Maybe<Scalars['DateTime']>;
}>;


export type BidsQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'CurrentUser', id?: Maybe<string>, officeBranch?: Maybe<{ __typename?: 'OfficeBranch', id?: Maybe<string>, code?: Maybe<string>, title?: Maybe<string>, isWorldwide?: Maybe<boolean> }>, bids?: Maybe<{ __typename?: 'BidPaginatedList', total: number, nodes: Array<{ __typename?: 'Bid', nowBest?: Maybe<boolean>, wasOverbid?: Maybe<boolean>, needPriorityPass?: Maybe<boolean>, isGreenCorner?: Maybe<boolean>, createTranslation?: Maybe<boolean>, isParticipationAccepted?: Maybe<boolean>, createdAt?: Maybe<any>, id?: Maybe<string>, status?: Maybe<BidStatusEnum>, updatedAt?: Maybe<any>, amount?: Maybe<number>, commission?: Maybe<number>, fullAmount?: Maybe<number>, bidCondition?: Maybe<{ __typename?: 'BidCondition', id?: Maybe<string>, isAuto?: Maybe<boolean>, isMoto?: Maybe<boolean>, isOnePrice?: Maybe<boolean>, minYear?: Maybe<number>, title?: Maybe<string> }>, bidGroup?: Maybe<{ __typename?: 'BidGroup', date: any, id?: Maybe<string>, letter: string, quantity: string, bidsLimitReached: boolean, lotsLimitReached: boolean }>, lot?: Maybe<{ __typename?: 'Lot', createdAt?: Maybe<any>, id?: Maybe<any>, title?: Maybe<string>, code?: Maybe<string>, year?: Maybe<string>, images?: Maybe<Array<string>>, link?: Maybe<string>, auctionDate?: Maybe<any>, auctionDatetime?: Maybe<any>, auctionName?: Maybe<string>, companyEn?: Maybe<string>, modelEn?: Maybe<string>, modelGradeEn?: Maybe<string>, modelTypeEn?: Maybe<string>, colorEn?: Maybe<string>, mileageNum?: Maybe<string>, status?: Maybe<LotStatusEnum>, negotiationsPrice?: Maybe<any>, negotiationsAvailable?: Maybe<boolean>, negotiationsEndsAt?: Maybe<any>, tradingClosed?: Maybe<boolean>, tradingClosureBiddingEndsAt?: Maybe<any>, ratingEn?: Maybe<string>, modelYearEn?: Maybe<string>, modelDetailsEn?: Maybe<string>, engineVolumeNum?: Maybe<number>, equipmentEn?: Maybe<string>, transmissionEn?: Maybe<string>, auctionSystem?: Maybe<string>, startPriceNum?: Maybe<string>, endPriceNum?: Maybe<string>, thumbnails?: Maybe<Array<string>>, updatedAt?: Maybe<any>, soldPrice?: Maybe<any>, translations?: Maybe<Array<{ __typename?: 'LotTranslation', id?: Maybe<string>, language?: Maybe<string>, message?: Maybe<string>, file?: Maybe<{ __typename?: 'S3File', filename?: Maybe<string>, fullPath?: Maybe<string>, id?: Maybe<string>, key?: Maybe<string> }> }>> }>, comments?: Maybe<Array<{ __typename?: 'BidComment', id?: Maybe<string>, content?: Maybe<string>, isManager?: Maybe<boolean>, createdAt?: Maybe<any>, user?: Maybe<{ __typename?: 'UserInfo', id?: Maybe<string>, username?: Maybe<string>, fullName?: Maybe<string> }> }>> }> }>, initialBidsCount?: Maybe<{ __typename?: 'BidPaginatedList', total: number }>, translatedBidsCount?: Maybe<{ __typename?: 'BidPaginatedList', total: number }>, confirmedBidsCount?: Maybe<{ __typename?: 'BidPaginatedList', total: number }>, wonBidsCount?: Maybe<{ __typename?: 'BidPaginatedList', total: number }>, canceledBidsCount?: Maybe<{ __typename?: 'BidPaginatedList', total: number }>, allBidsCount?: Maybe<{ __typename?: 'BidPaginatedList', total: number }> }>, bidConditions: Array<{ __typename?: 'BidCondition', id?: Maybe<string>, title?: Maybe<string>, isAuto?: Maybe<boolean>, isMoto?: Maybe<boolean>, isOnePrice?: Maybe<boolean>, isDisassembly?: Maybe<boolean>, minYear?: Maybe<number> }> };

export type BidConditionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BidConditionsQuery = { __typename?: 'Query', bidConditions: Array<{ __typename?: 'BidCondition', id?: Maybe<string>, title?: Maybe<string>, isAuto?: Maybe<boolean>, isMoto?: Maybe<boolean>, isOnePrice?: Maybe<boolean>, minYear?: Maybe<number> }> };

export type BoundaryLotsQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  filter?: Maybe<BoundaryLotsFilter>;
}>;


export type BoundaryLotsQuery = { __typename?: 'Query', boundaryLots?: Maybe<{ __typename?: 'LotPaginatedList', total: number, nodes: Array<{ __typename?: 'Lot', id?: Maybe<any>, code?: Maybe<string>, link?: Maybe<string>, auctionName?: Maybe<string>, auctionDatetime?: Maybe<any>, colorEn?: Maybe<string>, companyEn?: Maybe<string>, modelEn?: Maybe<string>, year?: Maybe<string>, status?: Maybe<LotStatusEnum>, transmissionEn?: Maybe<string>, images?: Maybe<Array<string>>, thumbnails?: Maybe<Array<string>>, startPriceNum?: Maybe<string>, endPriceNum?: Maybe<string>, engineVolumeNum?: Maybe<number>, mileageNum?: Maybe<string>, modelDetailsEn?: Maybe<string>, modelGradeEn?: Maybe<string>, modelTypeEn?: Maybe<string>, modelYearEn?: Maybe<string> }> }>, boundaryLotsCount?: Maybe<{ __typename?: 'LotPaginatedList', total: number }> };

export type CurrentLotMarksListsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentLotMarksListsQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'CurrentUser', lotMarksLists?: Maybe<Array<{ __typename?: 'UserLotMarksList', id?: Maybe<string>, path?: Maybe<string>, title?: Maybe<string>, images?: Maybe<Array<string>>, createdAt?: Maybe<any>, publishedAt?: Maybe<any>, description?: Maybe<string>, lotMarks?: Maybe<Array<{ __typename?: 'UserLotMark', id?: Maybe<string>, mark?: Maybe<UserLotMarkEnum>, viewsCount?: Maybe<number>, userLotMarksListTitle?: Maybe<string>, lot?: Maybe<{ __typename?: 'Lot', id?: Maybe<any> }> }>> }>> }> };

export type CurrentLotMarksQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  filter?: Maybe<AutoCurrentUserLotMarksFilter>;
}>;


export type CurrentLotMarksQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'CurrentUser', lotMarks?: Maybe<{ __typename?: 'UserLotMarkPaginatedList', nodes: Array<{ __typename?: 'UserLotMark', id?: Maybe<string>, mark?: Maybe<UserLotMarkEnum>, viewsCount?: Maybe<number>, lot?: Maybe<{ __typename?: 'Lot', id?: Maybe<any> }> }> }> }> };

export type CurrentUserMinimalQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserMinimalQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'CurrentUser', id?: Maybe<string>, username?: Maybe<string>, fullName?: Maybe<string>, limitLotsDaily?: Maybe<number>, limitLotBids?: Maybe<number>, preferredLang?: Maybe<PreferredLang>, countryIso?: Maybe<string>, defaultTranslationMediaType?: Maybe<TranslationMediaTypeEnum>, officeBranch?: Maybe<{ __typename?: 'OfficeBranch', id?: Maybe<string>, code?: Maybe<string>, title?: Maybe<string>, isWorldwide?: Maybe<boolean> }>, plan?: Maybe<{ __typename?: 'Plan', id?: Maybe<string>, title?: Maybe<any> }> }> };

export type HasActiveGuidanceRequestQueryVariables = Exact<{ [key: string]: never; }>;


export type HasActiveGuidanceRequestQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'CurrentUser', id?: Maybe<string>, hasActiveGuidanceRequest?: Maybe<boolean> }> };

export type ImportedBidsBiddingDataQueryVariables = Exact<{
  todayDate: Scalars['DateTime'];
}>;


export type ImportedBidsBiddingDataQuery = { __typename?: 'Query', autoMaxBidAmount?: Maybe<number>, motoMaxBidAmount?: Maybe<number>, onepriceMaxBidAmount?: Maybe<number>, autoMinBidCommission?: Maybe<number>, motoMinBidCommission?: Maybe<number>, onepriceMinBidCommission?: Maybe<number>, currentUser?: Maybe<{ __typename?: 'CurrentUser', id?: Maybe<string>, countryIso?: Maybe<string>, isOtherCountries?: Maybe<boolean>, maxBidAmountLimit?: Maybe<number>, isManager?: Maybe<boolean>, isTranslator?: Maybe<boolean>, isAuctioneer?: Maybe<boolean>, bidGroups?: Maybe<{ __typename?: 'BidGroupPaginatedList', total: number, nodes: Array<{ __typename?: 'BidGroup', id?: Maybe<string>, date: any, letter: string, quantity: string, bidsLimitReached: boolean, lotsLimitReached: boolean }> }>, officeBranch?: Maybe<{ __typename?: 'OfficeBranch', id?: Maybe<string>, code?: Maybe<string>, title?: Maybe<string>, isWorldwide?: Maybe<boolean> }> }>, bidConditions: Array<{ __typename?: 'BidCondition', id?: Maybe<string>, title?: Maybe<string>, isAuto?: Maybe<boolean>, isMoto?: Maybe<boolean>, isOnePrice?: Maybe<boolean>, isDisassembly?: Maybe<boolean>, minYear?: Maybe<number> }> };

export type ImportedLotsQueryVariables = Exact<{
  lotFilters: Array<CodeDateAuctionNameInput> | CodeDateAuctionNameInput;
}>;


export type ImportedLotsQuery = { __typename?: 'Query', lotsByKeys?: Maybe<Array<{ __typename?: 'Lot', id?: Maybe<any>, code?: Maybe<string>, link?: Maybe<string>, year?: Maybe<string>, images?: Maybe<Array<string>>, modelEn?: Maybe<string>, companyEn?: Maybe<string>, subgroup?: Maybe<LotTypeEnum>, modelTypeEn?: Maybe<string>, auctionName?: Maybe<string>, auctionDate?: Maybe<any>, auctionDatetime?: Maybe<any>, modelGradeEn?: Maybe<string>, transmissionEn?: Maybe<string>, engineVolumeNum?: Maybe<number>, colorEn?: Maybe<string>, ratingEn?: Maybe<string>, mileageNum?: Maybe<string>, startPriceNum?: Maybe<string>, soldPrice?: Maybe<any>, currentUserLotBidsLimitReached?: Maybe<boolean> }>> };

export type LotsCountersQueryVariables = Exact<{
  lotIds: Array<Scalars['String']> | Scalars['String'];
  subgroup: LotTypeEnum;
  lotSource: LotSource;
}>;


export type LotsCountersQuery = { __typename?: 'Query', lots?: Maybe<{ __typename?: 'LotPaginatedList', total: number, nodes: Array<{ __typename?: 'Lot', id?: Maybe<any>, bidsCount?: Maybe<number>, biddersCount?: Maybe<number>, viewsCount?: Maybe<number>, inFavoritesCount?: Maybe<number> }> }>, lotsViewsCounts?: Maybe<Array<{ __typename?: 'LotViewsCount', originalId: any, viewsCount: number }>> };

export type LotListDataQueryVariables = Exact<{
  lotIds: Array<Scalars['String']> | Scalars['String'];
  subgroup: LotTypeEnum;
  lotSource: LotSource;
}>;


export type LotListDataQuery = { __typename?: 'Query', lots?: Maybe<{ __typename?: 'LotPaginatedList', total: number, nodes: Array<{ __typename?: 'Lot', id?: Maybe<any>, soldPrice?: Maybe<any>, bidsCount?: Maybe<number>, biddersCount?: Maybe<number>, viewsCount?: Maybe<number>, inFavoritesCount?: Maybe<number>, currentUserLotMarks?: Maybe<Array<{ __typename?: 'UserLotMark', id?: Maybe<string>, mark?: Maybe<UserLotMarkEnum>, viewsCount?: Maybe<number>, userLotMarksListTitle?: Maybe<string>, lot?: Maybe<{ __typename?: 'Lot', id?: Maybe<any> }> }>>, currentUserLastBid?: Maybe<{ __typename?: 'Bid', id?: Maybe<string>, status?: Maybe<BidStatusEnum> }>, currentUserLastLotSourceView?: Maybe<{ __typename?: 'LotSourceView', id?: Maybe<string> }> }> }> };

export type LotQueryVariables = Exact<{
  id: Scalars['LotID'];
  subgroup: LotTypeEnum;
  lotSource: LotSource;
  siteDomain?: Maybe<Scalars['String']>;
}>;


export type LotQuery = { __typename?: 'Query', lotViewsCount?: Maybe<{ __typename?: 'LotViewsCount', originalId: any, viewsCount: number }>, lot?: Maybe<{ __typename?: 'Lot', createdAt?: Maybe<any>, id?: Maybe<any>, title?: Maybe<string>, code?: Maybe<string>, year?: Maybe<string>, images?: Maybe<Array<string>>, description?: Maybe<string>, auctionDate?: Maybe<any>, auctionDatetime?: Maybe<any>, auctionName?: Maybe<string>, companyEn?: Maybe<string>, modelEn?: Maybe<string>, modelGradeEn?: Maybe<string>, modelTypeEn?: Maybe<string>, colorEn?: Maybe<string>, mileageNum?: Maybe<string>, ratingEn?: Maybe<string>, modelYearEn?: Maybe<string>, modelDetailsEn?: Maybe<string>, equipmentEn?: Maybe<string>, transmissionEn?: Maybe<string>, auctionSystem?: Maybe<string>, startPriceNum?: Maybe<string>, endPriceNum?: Maybe<string>, engineVolumeNum?: Maybe<number>, thumbnails?: Maybe<Array<string>>, updatedAt?: Maybe<any>, soldPrice?: Maybe<any>, subgroup?: Maybe<LotTypeEnum>, bidsCount?: Maybe<number>, biddersCount?: Maybe<number>, viewsCount?: Maybe<number>, inFavoritesCount?: Maybe<number>, translations?: Maybe<Array<{ __typename?: 'LotTranslation', id?: Maybe<string>, language?: Maybe<string>, message?: Maybe<string>, file?: Maybe<{ __typename?: 'S3File', filename?: Maybe<string>, fullPath?: Maybe<string>, id?: Maybe<string>, key?: Maybe<string> }> }>> }> };

export type LotsInspectedQueryVariables = Exact<{
  lots: Array<LotInspectionInput> | LotInspectionInput;
}>;


export type LotsInspectedQuery = { __typename?: 'Query', lotsInspected?: Maybe<Array<{ __typename?: 'LotInspection', id: any, subgroup: LotTypeEnum, source: LotSource, inspected: boolean }>> };

export type LotsQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  filter?: Maybe<LotsFilter>;
  sort?: Maybe<LotsSort>;
}>;


export type LotsQuery = { __typename?: 'Query', lots?: Maybe<{ __typename?: 'LotPaginatedList', total: number, nodes: Array<{ __typename?: 'Lot', createdAt?: Maybe<any>, id?: Maybe<any>, title?: Maybe<string>, code?: Maybe<string>, year?: Maybe<string>, images?: Maybe<Array<string>>, auctionDate?: Maybe<any>, auctionDatetime?: Maybe<any>, auctionName?: Maybe<string>, companyEn?: Maybe<string>, modelEn?: Maybe<string>, modelGradeEn?: Maybe<string>, modelTypeEn?: Maybe<string>, colorEn?: Maybe<string>, mileageNum?: Maybe<string>, ratingEn?: Maybe<string>, modelYearEn?: Maybe<string>, modelDetailsEn?: Maybe<string>, equipmentEn?: Maybe<string>, transmissionEn?: Maybe<string>, auctionSystem?: Maybe<string>, startPriceNum?: Maybe<string>, endPriceNum?: Maybe<string>, engineVolumeNum?: Maybe<number>, thumbnails?: Maybe<Array<string>>, updatedAt?: Maybe<any>, soldPrice?: Maybe<any>, subgroup?: Maybe<LotTypeEnum>, bidsCount?: Maybe<number>, biddersCount?: Maybe<number>, viewsCount?: Maybe<number>, inFavoritesCount?: Maybe<number>, currentUserLotMarks?: Maybe<Array<{ __typename?: 'UserLotMark', id?: Maybe<string>, mark?: Maybe<UserLotMarkEnum>, viewsCount?: Maybe<number>, userLotMarksListTitle?: Maybe<string>, lot?: Maybe<{ __typename?: 'Lot', id?: Maybe<any> }> }>>, translations?: Maybe<Array<{ __typename?: 'LotTranslation', id?: Maybe<string>, language?: Maybe<string>, message?: Maybe<string>, file?: Maybe<{ __typename?: 'S3File', filename?: Maybe<string>, fullPath?: Maybe<string>, id?: Maybe<string>, key?: Maybe<string> }> }>> }> }> };

export type MarkedLotsQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  filter?: Maybe<AutoCurrentUserLotMarksFilter>;
  sort?: Maybe<AutoCurrentUserLotMarksSort>;
}>;


export type MarkedLotsQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'CurrentUser', id?: Maybe<string>, lotMarks?: Maybe<{ __typename?: 'UserLotMarkPaginatedList', total: number, nodes: Array<{ __typename?: 'UserLotMark', id?: Maybe<string>, lot?: Maybe<{ __typename?: 'Lot', id?: Maybe<any>, code?: Maybe<string>, link?: Maybe<string>, auctionName?: Maybe<string>, auctionDatetime?: Maybe<any>, colorEn?: Maybe<string>, companyEn?: Maybe<string>, modelEn?: Maybe<string>, year?: Maybe<string>, status?: Maybe<LotStatusEnum>, transmissionEn?: Maybe<string>, images?: Maybe<Array<string>>, thumbnails?: Maybe<Array<string>>, startPriceNum?: Maybe<string>, endPriceNum?: Maybe<string>, engineVolumeNum?: Maybe<number>, mileageNum?: Maybe<string>, modelDetailsEn?: Maybe<string>, modelGradeEn?: Maybe<string>, modelTypeEn?: Maybe<string>, modelYearEn?: Maybe<string> }> }> }>, lotMarksLists?: Maybe<Array<{ __typename?: 'UserLotMarksList', id?: Maybe<string>, path?: Maybe<string>, title?: Maybe<string>, publishedAt?: Maybe<any> }>>, userChannel?: Maybe<{ __typename?: 'UserChannel', id?: Maybe<string>, path?: Maybe<string>, title?: Maybe<string>, userId?: Maybe<string>, images?: Maybe<Array<string>>, updatedAt?: Maybe<any>, createdAt?: Maybe<any>, publishedAt?: Maybe<any>, description?: Maybe<string> }> }> };

export type NegotiationLotsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type NegotiationLotsCountQuery = { __typename?: 'Query', negotiationLotsCount?: Maybe<number> };

export type SanctionsServiceDataQueryVariables = Exact<{ [key: string]: never; }>;


export type SanctionsServiceDataQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'CurrentUser', id?: Maybe<string>, isTranslator?: Maybe<boolean>, isAuctioneer?: Maybe<boolean> }> };

export type UserCountryIsoQueryVariables = Exact<{ [key: string]: never; }>;


export type UserCountryIsoQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'CurrentUser', id?: Maybe<string>, countryIso?: Maybe<string> }> };

export type UserFilterPresetsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserFilterPresetsQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'CurrentUser', id?: Maybe<string>, userFilterPresets?: Maybe<Array<{ __typename?: 'UserFilterPreset', id?: Maybe<string>, title?: Maybe<string>, content?: Maybe<any>, compilationEmailEnabled?: Maybe<boolean> }>> }> };

export type UserLimitsDataQueryVariables = Exact<{
  auctionDate: Scalars['DateTime'];
}>;


export type UserLimitsDataQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'CurrentUser', id?: Maybe<string>, lotsLimitReached?: Maybe<boolean>, lotProductionDateCheckRequestsLimitReached?: Maybe<boolean>, permissions?: Maybe<Array<{ __typename?: 'Permission', id?: Maybe<string>, code?: Maybe<string> }>> }> };

export type UserLotMarkQueryVariables = Exact<{
  id: Scalars['LotID'];
  subgroup: LotTypeEnum;
  lotSource: LotSource;
}>;


export type UserLotMarkQuery = { __typename?: 'Query', lot?: Maybe<{ __typename?: 'Lot', currentUserLotMarks?: Maybe<Array<{ __typename?: 'UserLotMark', viewsCount?: Maybe<number>, userLotMarksListTitle?: Maybe<string>, id?: Maybe<string>, mark?: Maybe<UserLotMarkEnum>, lot?: Maybe<{ __typename?: 'Lot', id?: Maybe<any>, subgroup?: Maybe<LotTypeEnum> }> }>> }> };

export type UserLotMarksQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  filter?: Maybe<AutoCurrentUserLotMarksFilter>;
}>;


export type UserLotMarksQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'CurrentUser', id?: Maybe<string>, lotMarks?: Maybe<{ __typename?: 'UserLotMarkPaginatedList', total: number, nodes: Array<{ __typename?: 'UserLotMark', id?: Maybe<string>, mark?: Maybe<UserLotMarkEnum>, lot?: Maybe<{ __typename?: 'Lot', id?: Maybe<any>, subgroup?: Maybe<LotTypeEnum> }> }> }> }> };

export type UserLotQueryVariables = Exact<{
  id: Scalars['LotID'];
  subgroup: LotTypeEnum;
  lotSource: LotSource;
  siteDomain?: Maybe<Scalars['String']>;
}>;


export type UserLotQuery = { __typename?: 'Query', lotViewsCount?: Maybe<{ __typename?: 'LotViewsCount', originalId: any, viewsCount: number }>, currentUser?: Maybe<{ __typename?: 'CurrentUser', id?: Maybe<string>, isOtherCountries?: Maybe<boolean>, hideBidAmount?: Maybe<boolean>, preferredLang?: Maybe<PreferredLang>, countryIso?: Maybe<string>, defaultTranslationMediaType?: Maybe<TranslationMediaTypeEnum>, canSeeBestBid?: Maybe<boolean>, canSeeBestBidAdmin?: Maybe<boolean>, isTranslator?: Maybe<boolean>, isAuctioneer?: Maybe<boolean>, isEmployee?: Maybe<boolean>, hasClearPhotos?: Maybe<boolean>, canCheckProductionDate?: Maybe<boolean>, canRecheckProductionDate?: Maybe<boolean>, canEditStartPrice?: Maybe<boolean>, canEditEngineVolume?: Maybe<boolean>, canSeeUsersBids?: Maybe<boolean>, canUpdateLotInfo?: Maybe<boolean>, canDownloadUssPhotos?: Maybe<boolean>, bestBidViewServiceSubscription?: Maybe<{ __typename?: 'ServiceSubscription', id?: Maybe<string>, expiresAt?: Maybe<any> }> }>, auctions: Array<{ __typename?: 'Auction', id?: Maybe<string>, title?: Maybe<string>, cartrackAuctionId?: Maybe<string>, auctionAliases?: Maybe<Array<{ __typename?: 'Auction', id?: Maybe<string>, title?: Maybe<string> }>> }>, lot?: Maybe<{ __typename?: 'Lot', createdAt?: Maybe<any>, canRecognizeAuctionList?: Maybe<boolean>, id?: Maybe<any>, vin?: Maybe<string>, images?: Maybe<Array<string>>, thumbnails?: Maybe<Array<string>>, code?: Maybe<string>, description?: Maybe<string>, auctionDate?: Maybe<any>, auctionDatetime?: Maybe<any>, auctionName?: Maybe<string>, companyEn?: Maybe<string>, modelEn?: Maybe<string>, modelGradeEn?: Maybe<string>, modelTypeEn?: Maybe<string>, colorEn?: Maybe<string>, mileageNum?: Maybe<string>, year?: Maybe<string>, status?: Maybe<LotStatusEnum>, ratingEn?: Maybe<string>, modelYearEn?: Maybe<string>, modelDetailsEn?: Maybe<string>, equipmentEn?: Maybe<string>, transmissionEn?: Maybe<string>, auctionSystem?: Maybe<string>, startPriceNum?: Maybe<string>, engineVolumeNum?: Maybe<number>, endPriceNum?: Maybe<string>, soldPrice?: Maybe<any>, latestBid?: Maybe<number>, icons?: Maybe<Array<LotIconEnum>>, jupiterLotData?: Maybe<any>, kawasakiLotData?: Maybe<any>, canToggleTranslationsHidden?: Maybe<boolean>, expectedTranslationInSeconds?: Maybe<number>, isRestricted?: Maybe<boolean>, negotiationsPrice?: Maybe<any>, canOpenNegotiations?: Maybe<boolean>, canEditNegotiationsPrice?: Maybe<boolean>, negotiationsAvailable?: Maybe<boolean>, negotiationsEndsAt?: Maybe<any>, tradingClosed?: Maybe<boolean>, tradingClosureBiddingEndsAt?: Maybe<any>, updatedAt?: Maybe<any>, productionDate?: Maybe<any>, productionDatePayload?: Maybe<any>, currentUserLotBidsLimitReached?: Maybe<boolean>, currentUserLimitsOverrideAvailable?: Maybe<boolean>, hasBestBid?: Maybe<boolean>, bidsCount?: Maybe<number>, biddersCount?: Maybe<number>, viewsCount?: Maybe<number>, inFavoritesCount?: Maybe<number>, currentUserLotMarks?: Maybe<Array<{ __typename?: 'UserLotMark', viewsCount?: Maybe<number>, userLotMarksListTitle?: Maybe<string>, id?: Maybe<string>, mark?: Maybe<UserLotMarkEnum>, lot?: Maybe<{ __typename?: 'Lot', id?: Maybe<any>, subgroup?: Maybe<LotTypeEnum> }> }>>, translations?: Maybe<Array<{ __typename?: 'LotTranslation', id?: Maybe<string>, language?: Maybe<string>, message?: Maybe<string>, aiModel?: Maybe<string>, aiProvider?: Maybe<string>, likesCount?: Maybe<number>, dislikesCount?: Maybe<number>, translatorId?: Maybe<string>, currentUserTranslationFeedback?: Maybe<{ __typename?: 'TranslationFeedback', akebonoLotTranslationId?: Maybe<string>, feedbackType?: Maybe<TranslationFeedbackTypeEnum>, id?: Maybe<string>, userId?: Maybe<string>, message?: Maybe<string> }>, file?: Maybe<{ __typename?: 'S3File', filename?: Maybe<string>, fullPath?: Maybe<string>, id?: Maybe<string>, key?: Maybe<string> }> }>>, lotSetting?: Maybe<{ __typename?: 'LotSetting', translationsHidden?: Maybe<boolean> }>, currentUserLastBid?: Maybe<{ __typename?: 'Bid', id?: Maybe<string>, status?: Maybe<BidStatusEnum>, wasOverbid?: Maybe<boolean>, isNegotiationsAccepted?: Maybe<boolean>, isParticipationAccepted?: Maybe<boolean>, translationComplete?: Maybe<boolean>, createTranslation?: Maybe<boolean>, nowBest?: Maybe<boolean>, needPriorityPass?: Maybe<boolean>, isGreenCorner?: Maybe<boolean>, createdAt?: Maybe<any>, amount?: Maybe<number>, commission?: Maybe<number>, fullAmount?: Maybe<number>, user?: Maybe<{ __typename?: 'UserInfo', id?: Maybe<string> }>, bidGroup?: Maybe<{ __typename?: 'BidGroup', id?: Maybe<string>, date: any, letter: string, quantity: string }> }>, currentUserLotNote?: Maybe<{ __typename?: 'LotNote', createdAt?: Maybe<any>, id?: Maybe<string>, lotId?: Maybe<string>, note?: Maybe<string>, updatedAt?: Maybe<any>, userId?: Maybe<string> }>, bestBid?: Maybe<{ __typename?: 'Bid', id?: Maybe<string>, isByCurrentUser?: Maybe<boolean>, amount?: Maybe<number>, commission?: Maybe<number>, fullAmount?: Maybe<number>, user?: Maybe<{ __typename?: 'UserInfo', id?: Maybe<string>, fullName?: Maybe<string> }> }>, bids?: Maybe<Array<{ __typename?: 'Bid', id?: Maybe<string>, status?: Maybe<BidStatusEnum>, isGreenCorner?: Maybe<boolean>, createTranslation?: Maybe<boolean>, notify?: Maybe<boolean>, createdAt?: Maybe<any>, needPriorityPass?: Maybe<boolean>, amount?: Maybe<number>, commission?: Maybe<number>, fullAmount?: Maybe<number>, bidCondition?: Maybe<{ __typename?: 'BidCondition', id?: Maybe<string>, title?: Maybe<string> }>, bidGroup?: Maybe<{ __typename?: 'BidGroup', id?: Maybe<string>, letter: string, quantity: string }>, user?: Maybe<{ __typename?: 'UserInfo', id?: Maybe<string>, fullName?: Maybe<string>, hasActiveBestBidViewServiceSubscription?: Maybe<boolean> }> }>>, versions?: Maybe<Array<{ __typename?: 'TrailEvent', changeset?: Maybe<any>, versionNumber?: Maybe<number>, createdAt?: Maybe<any>, author?: Maybe<{ __typename?: 'TrailEventAuthor', id?: Maybe<string>, fullName?: Maybe<string>, username?: Maybe<string>, countryIso?: Maybe<string> }> }>>, lotSourceViews?: Maybe<Array<{ __typename?: 'LotSourceView', id?: Maybe<string>, createdAt: any, user: { __typename?: 'UserInfo', id?: Maybe<string>, username?: Maybe<string>, fullName?: Maybe<string> } }>>, currentUserLastLotSourceView?: Maybe<{ __typename?: 'LotSourceView', id?: Maybe<string>, updatedAt: any }> }> };

export type UserPurchaseStatisticsQueryVariables = Exact<{
  todayDate: Scalars['DateTime'];
  yesterdayDate: Scalars['DateTime'];
  weekStartDate: Scalars['DateTime'];
}>;


export type UserPurchaseStatisticsQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'CurrentUser', id?: Maybe<string>, todayPurchases?: Maybe<{ __typename?: 'BidPaginatedList', total: number }>, yesterdayPurchases?: Maybe<{ __typename?: 'BidPaginatedList', total: number }>, weekPurchases?: Maybe<{ __typename?: 'BidPaginatedList', total: number }> }> };

export type UserSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSettingsQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'CurrentUser', id?: Maybe<string>, hideBidAmount?: Maybe<boolean>, bidTranslationByDefault?: Maybe<boolean>, ignoreSmallBidWarning?: Maybe<boolean>, isOtherCountries?: Maybe<boolean>, preferredLang?: Maybe<PreferredLang>, countryIso?: Maybe<string>, defaultTranslationMediaType?: Maybe<TranslationMediaTypeEnum>, notificationSettings?: Maybe<any>, canSeeBestBid?: Maybe<boolean>, canSeeBestBidAdmin?: Maybe<boolean>, bestBidViewServiceSubscription?: Maybe<{ __typename?: 'ServiceSubscription', id?: Maybe<string>, expiresAt?: Maybe<any> }> }> };

export type UserViewBestBidSubscribeDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UserViewBestBidSubscribeDataQuery = { __typename?: 'Query', currentUser?: Maybe<{ __typename?: 'CurrentUser', id?: Maybe<string>, isTrusted?: Maybe<boolean>, isEnoughFundsToSubscribeToViewTheBestBid?: Maybe<boolean> }> };

export type VinCheckerInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type VinCheckerInfoQuery = { __typename?: 'Query', vincheckerInfo?: Maybe<Array<{ __typename?: 'VincheckerInfo', chassisId?: Maybe<string>, maker?: Maybe<string>, necessaryDigitInBodyNumber?: Maybe<string>, rangeEndDate?: Maybe<string>, rangeStartDate?: Maybe<string> }>> };

export const AlertFragmentDoc = gql`
    fragment Alert on Alert {
  id
  style
  target
  contentEn
  contentRu
  isOnetime
  countryIso
}
    `;
export const AuctionSheetZoneFragmentDoc = gql`
    fragment AuctionSheetZone on AuctionSheetZone {
  id
  code
  zoneType
  x
  y
  w
  h
}
    `;
export const BidAmountFragmentDoc = gql`
    fragment BidAmount on Bid {
  id
  amount
  commission
  fullAmount
}
    `;
export const BidCommentsFragmentDoc = gql`
    fragment BidComments on Bid {
  comments {
    id
    content
    isManager
    createdAt
    user {
      id
      username
      fullName
    }
  }
}
    `;
export const CurrentTradingTimeShiftFragmentDoc = gql`
    fragment CurrentTradingTimeShift on AuctionTradingTimeShift {
  auctionDate
  codeFrom
  codeTo
  id
  shiftInSeconds
  speedUp
}
    `;
export const ImportedLotFragmentDoc = gql`
    fragment ImportedLot on Lot {
  id
  code
  link
  year
  images
  modelEn
  companyEn
  subgroup
  modelTypeEn
  auctionName
  auctionDate
  auctionDatetime
  modelGradeEn
  transmissionEn
  engineVolumeNum
  colorEn
  ratingEn
  mileageNum
  startPriceNum
  soldPrice
  currentUserLotBidsLimitReached
}
    `;
export const LotCountersFragmentDoc = gql`
    fragment LotCounters on Lot {
  id
  bidsCount
  biddersCount
  viewsCount
  inFavoritesCount
}
    `;
export const UserLotMarkFragmentDoc = gql`
    fragment UserLotMark on UserLotMark {
  id
  mark
  viewsCount
  userLotMarksListTitle
  lot {
    id
  }
}
    `;
export const LotDataFragmentDoc = gql`
    fragment LotData on Lot {
  id
  soldPrice
  ...LotCounters
  currentUserLotMarks {
    ...UserLotMark
  }
  currentUserLastBid {
    id
    status
  }
  currentUserLastLotSourceView {
    id
  }
}
    ${LotCountersFragmentDoc}
${UserLotMarkFragmentDoc}`;
export const CurrentUserTranslationFeedbackFragmentDoc = gql`
    fragment CurrentUserTranslationFeedback on TranslationFeedback {
  akebonoLotTranslationId
  feedbackType
  id
  userId
  message
}
    `;
export const LotTranslationFragmentDoc = gql`
    fragment LotTranslation on LotTranslation {
  id
  language
  message
  aiModel
  aiProvider
  likesCount
  dislikesCount
  currentUserTranslationFeedback {
    ...CurrentUserTranslationFeedback
  }
  file {
    filename
    fullPath
    id
    key
  }
  translatorId
}
    ${CurrentUserTranslationFeedbackFragmentDoc}`;
export const LotVersionsFragmentDoc = gql`
    fragment LotVersions on Lot {
  id
  code
  modelEn
  colorEn
  companyEn
  auctionName
  versions {
    changeset
    versionNumber
    createdAt
    author {
      id
      fullName
      username
      countryIso
    }
  }
}
    `;
export const LotViewsCountFragmentDoc = gql`
    fragment LotViewsCount on LotViewsCount {
  originalId
  viewsCount
}
    `;
export const LotViewsFragmentDoc = gql`
    fragment LotViews on Lot {
  lotSourceViews {
    id
    createdAt
    user {
      id
      username
      fullName
    }
  }
  currentUserLastLotSourceView {
    id
    updatedAt
  }
}
    `;
export const UniversalLotTableFragmentDoc = gql`
    fragment UniversalLotTable on Lot {
  id
  code
  link
  auctionName
  auctionDatetime
  colorEn
  companyEn
  modelEn
  year
  status
  transmissionEn
  images
  thumbnails
  startPriceNum
  endPriceNum
  engineVolumeNum
  mileageNum
  modelDetailsEn
  modelGradeEn
  modelTypeEn
  modelYearEn
}
    `;
export const UserViewBestBidSubscriptionDataFragmentDoc = gql`
    fragment UserViewBestBidSubscriptionData on CurrentUser {
  id
  canSeeBestBid: hasPermission(code: "cars.best-bid")
  canSeeBestBidAdmin: hasPermission(code: "cars.best-bid-admin")
  bestBidViewServiceSubscription {
    id
    expiresAt
  }
}
    `;
export const UserBidSettingsFragmentDoc = gql`
    fragment UserBidSettings on CurrentUser {
  id
  hideBidAmount
  bidTranslationByDefault
  ignoreSmallBidWarning
  isOtherCountries
  ...UserViewBestBidSubscriptionData
}
    ${UserViewBestBidSubscriptionDataFragmentDoc}`;
export const UserLotMarkDataFragmentDoc = gql`
    fragment UserLotMarkData on UserLotMark {
  id
  mark
  lot {
    id
    subgroup
  }
}
    `;
export const UserNotificationSettingsFragmentDoc = gql`
    fragment UserNotificationSettings on CurrentUser {
  id
  notificationSettings
}
    `;
export const UserTranslationSettingsFragmentDoc = gql`
    fragment UserTranslationSettings on CurrentUser {
  id
  preferredLang
  countryIso
  defaultTranslationMediaType
}
    `;
export const BidCommentCreateDocument = gql`
    mutation bidCommentCreate($input: BidCommentCreateInput!) {
  bidCommentCreate(input: $input) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BidCommentCreateGQL extends Apollo.Mutation<BidCommentCreateMutation, BidCommentCreateMutationVariables> {
    document = BidCommentCreateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BidCreateManualDocument = gql`
    mutation bidCreateManual($input: BidCreateManualInput!) {
  bidCreateManual(input: $input) {
    clientMutationId
    error {
      backtrace
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BidCreateManualGQL extends Apollo.Mutation<BidCreateManualMutation, BidCreateManualMutationVariables> {
    document = BidCreateManualDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BidCreateDocument = gql`
    mutation bidCreate($input: BidCreateInput!) {
  bidCreate(input: $input) {
    clientMutationId
    hint {
      text
      triesLeft
    }
    error {
      backtrace
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BidCreateGQL extends Apollo.Mutation<BidCreateMutation, BidCreateMutationVariables> {
    document = BidCreateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BidDeleteRequestCreateDocument = gql`
    mutation bidDeleteRequestCreate($input: BidDeleteRequestCreateInput!) {
  bidDeleteRequestCreate(input: $input) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BidDeleteRequestCreateGQL extends Apollo.Mutation<BidDeleteRequestCreateMutation, BidDeleteRequestCreateMutationVariables> {
    document = BidDeleteRequestCreateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BidGroupCreateDocument = gql`
    mutation bidGroupCreate($input: BidGroupCreateInput!) {
  bidGroupCreate(input: $input) {
    clientMutationId
    error {
      backtrace
      code
      message
    }
    group {
      id
      letter
      quantity
      date
      bidsLimitReached
      lotsLimitReached
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BidGroupCreateGQL extends Apollo.Mutation<BidGroupCreateMutation, BidGroupCreateMutationVariables> {
    document = BidGroupCreateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BidUpdateDocument = gql`
    mutation bidUpdate($input: BidUpdateInput!) {
  bidUpdate(input: $input) {
    clientMutationId
    error {
      backtrace
      code
      message
    }
    bid {
      id
      isNegotiationsAccepted
      isParticipationAccepted
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BidUpdateGQL extends Apollo.Mutation<BidUpdateMutation, BidUpdateMutationVariables> {
    document = BidUpdateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GuidanceRequestCreateDocument = gql`
    mutation guidanceRequestCreate($input: GuidanceRequestCreateInput!) {
  guidanceRequestCreate(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GuidanceRequestCreateGQL extends Apollo.Mutation<GuidanceRequestCreateMutation, GuidanceRequestCreateMutationVariables> {
    document = GuidanceRequestCreateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotAiTranslationCreateDocument = gql`
    mutation lotAiTranslationCreate($input: LotAiTranslationCreateInput!) {
  lotAiTranslationCreate(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LotAiTranslationCreateGQL extends Apollo.Mutation<LotAiTranslationCreateMutation, LotAiTranslationCreateMutationVariables> {
    document = LotAiTranslationCreateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotAraiKenkiPhotoFetchDocument = gql`
    mutation lotAraiKenkiPhotoFetch($input: LotAraiKenkiPhotoFetchInput!) {
  lotAraiKenkiPhotoFetch(input: $input) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LotAraiKenkiPhotoFetchGQL extends Apollo.Mutation<LotAraiKenkiPhotoFetchMutation, LotAraiKenkiPhotoFetchMutationVariables> {
    document = LotAraiKenkiPhotoFetchDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotAutoTranslationCreateDocument = gql`
    mutation lotAutoTranslationCreate($input: LotAutoTranslationCreateInput!) {
  lotAutoTranslationCreate(input: $input) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LotAutoTranslationCreateGQL extends Apollo.Mutation<LotAutoTranslationCreateMutation, LotAutoTranslationCreateMutationVariables> {
    document = LotAutoTranslationCreateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotCreateManualDocument = gql`
    mutation lotCreateManual($input: LotCreateManualInput!) {
  lotCreateManual(input: $input) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LotCreateManualGQL extends Apollo.Mutation<LotCreateManualMutation, LotCreateManualMutationVariables> {
    document = LotCreateManualDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotIncrementViewsCountDocument = gql`
    mutation lotIncrementViewsCount($input: LotIncrementViewsCountInput!) {
  lotIncrementViewsCount(input: $input) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LotIncrementViewsCountGQL extends Apollo.Mutation<LotIncrementViewsCountMutation, LotIncrementViewsCountMutationVariables> {
    document = LotIncrementViewsCountDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotNegotiationsOpenDocument = gql`
    mutation lotNegotiationsOpen($input: LotNegotiationsOpenInput!) {
  lotNegotiationsOpen(input: $input) {
    lot {
      id
      status
      negotiationsPrice
      canOpenNegotiations
      canEditNegotiationsPrice
      negotiationsAvailable
      negotiationsEndsAt
      tradingClosed
      tradingClosureBiddingEndsAt
    }
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LotNegotiationsOpenGQL extends Apollo.Mutation<LotNegotiationsOpenMutation, LotNegotiationsOpenMutationVariables> {
    document = LotNegotiationsOpenDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotNoteCreateDocument = gql`
    mutation lotNoteCreate($input: LotNoteCreateInput!) {
  lotNoteCreate(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LotNoteCreateGQL extends Apollo.Mutation<LotNoteCreateMutation, LotNoteCreateMutationVariables> {
    document = LotNoteCreateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotNoteDeleteDocument = gql`
    mutation lotNoteDelete($input: LotNoteDeleteInput!) {
  lotNoteDelete(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LotNoteDeleteGQL extends Apollo.Mutation<LotNoteDeleteMutation, LotNoteDeleteMutationVariables> {
    document = LotNoteDeleteDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotNoteUpdateDocument = gql`
    mutation lotNoteUpdate($input: LotNoteUpdateInput!) {
  lotNoteUpdate(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LotNoteUpdateGQL extends Apollo.Mutation<LotNoteUpdateMutation, LotNoteUpdateMutationVariables> {
    document = LotNoteUpdateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotPhotoFetchDocument = gql`
    mutation lotPhotoFetch($input: LotPhotoFetchInput!) {
  lotPhotoFetch(input: $input) {
    lot {
      id
      images
      thumbnails
    }
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LotPhotoFetchGQL extends Apollo.Mutation<LotPhotoFetchMutation, LotPhotoFetchMutationVariables> {
    document = LotPhotoFetchDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotPhotoRequestDocument = gql`
    mutation lotPhotoRequest($input: LotPhotoRequestInput!) {
  lotPhotoRequest(input: $input) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LotPhotoRequestGQL extends Apollo.Mutation<LotPhotoRequestMutation, LotPhotoRequestMutationVariables> {
    document = LotPhotoRequestDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotProductionDateCheckRequestCreateDocument = gql`
    mutation lotProductionDateCheckRequestCreate($input: LotProductionDateCheckRequestCreateInput!) {
  lotProductionDateCheckRequestCreate(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LotProductionDateCheckRequestCreateGQL extends Apollo.Mutation<LotProductionDateCheckRequestCreateMutation, LotProductionDateCheckRequestCreateMutationVariables> {
    document = LotProductionDateCheckRequestCreateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotProductionDateFetchDocument = gql`
    mutation lotProductionDateFetch($input: LotProductionDateFetchInput!) {
  lotProductionDateFetch(input: $input) {
    lot {
      id
      vin
      productionDate
      productionDatePayload
      kawasakiLotData
    }
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LotProductionDateFetchGQL extends Apollo.Mutation<LotProductionDateFetchMutation, LotProductionDateFetchMutationVariables> {
    document = LotProductionDateFetchDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotResetDocument = gql`
    mutation lotReset($input: LotResetInput!) {
  lotReset(input: $input) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LotResetGQL extends Apollo.Mutation<LotResetMutation, LotResetMutationVariables> {
    document = LotResetDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotSettingsUpdateDocument = gql`
    mutation lotSettingsUpdate($input: LotSettingsUpdateInput!) {
  lotSettingsUpdate(input: $input) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LotSettingsUpdateGQL extends Apollo.Mutation<LotSettingsUpdateMutation, LotSettingsUpdateMutationVariables> {
    document = LotSettingsUpdateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotTranslateRequestCreateDocument = gql`
    mutation lotTranslateRequestCreate($input: LotTranslateRequestCreateInput!) {
  lotTranslateRequestCreate(input: $input) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LotTranslateRequestCreateGQL extends Apollo.Mutation<LotTranslateRequestCreateMutation, LotTranslateRequestCreateMutationVariables> {
    document = LotTranslateRequestCreateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotUpdateDocument = gql`
    mutation lotUpdate($input: LotUpdateInput!) {
  lotUpdate(input: $input) {
    lot {
      id
      icons
      images
      thumbnails
    }
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LotUpdateGQL extends Apollo.Mutation<LotUpdateMutation, LotUpdateMutationVariables> {
    document = LotUpdateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotPhotoBotRequestDocument = gql`
    mutation lotPhotoBotRequest($input: LotPhotoBotRequestInput!) {
  lotPhotoBotRequest(input: $input) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LotPhotoBotRequestGQL extends Apollo.Mutation<LotPhotoBotRequestMutation, LotPhotoBotRequestMutationVariables> {
    document = LotPhotoBotRequestDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NotificationSettingsUpdateDocument = gql`
    mutation notificationSettingsUpdate($input: NotificationSettingsUpdateInput!) {
  notificationSettingsUpdate(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NotificationSettingsUpdateGQL extends Apollo.Mutation<NotificationSettingsUpdateMutation, NotificationSettingsUpdateMutationVariables> {
    document = NotificationSettingsUpdateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PlugViewBestBidSubscriptionOnAdvanceUpdateRequestCreateDocument = gql`
    mutation plugViewBestBidSubscriptionOnAdvanceUpdateRequestCreate($input: PlugViewBestBidSubscriptionOnAdvanceUpdateRequestCreateInput!) {
  plugViewBestBidSubscriptionOnAdvanceUpdateRequestCreate(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PlugViewBestBidSubscriptionOnAdvanceUpdateRequestCreateGQL extends Apollo.Mutation<PlugViewBestBidSubscriptionOnAdvanceUpdateRequestCreateMutation, PlugViewBestBidSubscriptionOnAdvanceUpdateRequestCreateMutationVariables> {
    document = PlugViewBestBidSubscriptionOnAdvanceUpdateRequestCreateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PresignedPostCreateDocument = gql`
    mutation presignedPostCreate($input: PresignedPostCreateInput!) {
  presignedPostCreate(input: $input) {
    clientMutationId
    error {
      code
      message
    }
    fields
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PresignedPostCreateGQL extends Apollo.Mutation<PresignedPostCreateMutation, PresignedPostCreateMutationVariables> {
    document = PresignedPostCreateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductionDateFetchDocument = gql`
    mutation productionDateFetch($input: ProductionDateFetchInput!) {
  productionDateFetch(input: $input) {
    clientMutationId
    data
    productionDate
    productionDateGte
    productionDateLte
    error {
      backtrace
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductionDateFetchGQL extends Apollo.Mutation<ProductionDateFetchMutation, ProductionDateFetchMutationVariables> {
    document = ProductionDateFetchDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TranslationFeedbackCreateDocument = gql`
    mutation translationFeedbackCreate($input: TranslationFeedbackCreateInput!) {
  translationFeedbackCreate(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TranslationFeedbackCreateGQL extends Apollo.Mutation<TranslationFeedbackCreateMutation, TranslationFeedbackCreateMutationVariables> {
    document = TranslationFeedbackCreateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TranslationFeedbackDeleteDocument = gql`
    mutation translationFeedbackDelete($input: TranslationFeedbackDeleteInput!) {
  translationFeedbackDelete(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TranslationFeedbackDeleteGQL extends Apollo.Mutation<TranslationFeedbackDeleteMutation, TranslationFeedbackDeleteMutationVariables> {
    document = TranslationFeedbackDeleteDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TranslationFeedbackUpdateDocument = gql`
    mutation translationFeedbackUpdate($input: TranslationFeedbackUpdateInput!) {
  translationFeedbackUpdate(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TranslationFeedbackUpdateGQL extends Apollo.Mutation<TranslationFeedbackUpdateMutation, TranslationFeedbackUpdateMutationVariables> {
    document = TranslationFeedbackUpdateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserChannelCreateDocument = gql`
    mutation userChannelCreate($input: UserChannelCreateInput!) {
  userChannelCreate(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserChannelCreateGQL extends Apollo.Mutation<UserChannelCreateMutation, UserChannelCreateMutationVariables> {
    document = UserChannelCreateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserChannelDeleteDocument = gql`
    mutation userChannelDelete($input: UserChannelDeleteInput!) {
  userChannelDelete(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserChannelDeleteGQL extends Apollo.Mutation<UserChannelDeleteMutation, UserChannelDeleteMutationVariables> {
    document = UserChannelDeleteDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserChannelUpdateDocument = gql`
    mutation userChannelUpdate($input: UserChannelUpdateInput!) {
  userChannelUpdate(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserChannelUpdateGQL extends Apollo.Mutation<UserChannelUpdateMutation, UserChannelUpdateMutationVariables> {
    document = UserChannelUpdateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserFilterPresetCreateDocument = gql`
    mutation userFilterPresetCreate($input: UserFilterPresetCreateInput!) {
  userFilterPresetCreate(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserFilterPresetCreateGQL extends Apollo.Mutation<UserFilterPresetCreateMutation, UserFilterPresetCreateMutationVariables> {
    document = UserFilterPresetCreateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserFilterPresetDeleteDocument = gql`
    mutation userFilterPresetDelete($input: UserFilterPresetDeleteInput!) {
  userFilterPresetDelete(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserFilterPresetDeleteGQL extends Apollo.Mutation<UserFilterPresetDeleteMutation, UserFilterPresetDeleteMutationVariables> {
    document = UserFilterPresetDeleteDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserFilterPresetUpdateDocument = gql`
    mutation userFilterPresetUpdate($input: UserFilterPresetUpdateInput!) {
  userFilterPresetUpdate(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserFilterPresetUpdateGQL extends Apollo.Mutation<UserFilterPresetUpdateMutation, UserFilterPresetUpdateMutationVariables> {
    document = UserFilterPresetUpdateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserLotMarkCreateDocument = gql`
    mutation userLotMarkCreate($input: UserLotMarkCreateInput!) {
  userLotMarkCreate(input: $input) {
    clientMutationId
    userLotMark {
      ...UserLotMarkData
    }
    error {
      code
      message
    }
  }
}
    ${UserLotMarkDataFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserLotMarkCreateGQL extends Apollo.Mutation<UserLotMarkCreateMutation, UserLotMarkCreateMutationVariables> {
    document = UserLotMarkCreateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserLotMarkDeleteDocument = gql`
    mutation userLotMarkDelete($input: UserLotMarkDeleteInput!) {
  userLotMarkDelete(input: $input) {
    clientMutationId
    userLotMark {
      ...UserLotMarkData
    }
    error {
      code
      message
    }
  }
}
    ${UserLotMarkDataFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserLotMarkDeleteGQL extends Apollo.Mutation<UserLotMarkDeleteMutation, UserLotMarkDeleteMutationVariables> {
    document = UserLotMarkDeleteDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserLotMarkUpdateDocument = gql`
    mutation userLotMarkUpdate($input: UserLotMarkUpdateInput!) {
  userLotMarkUpdate(input: $input) {
    clientMutationId
    userLotMark {
      ...UserLotMarkData
    }
    error {
      code
      message
    }
  }
}
    ${UserLotMarkDataFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserLotMarkUpdateGQL extends Apollo.Mutation<UserLotMarkUpdateMutation, UserLotMarkUpdateMutationVariables> {
    document = UserLotMarkUpdateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserLotMarksListClearDocument = gql`
    mutation userLotMarksListClear($input: UserLotMarksListClearInput!) {
  userLotMarksListClear(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserLotMarksListClearGQL extends Apollo.Mutation<UserLotMarksListClearMutation, UserLotMarksListClearMutationVariables> {
    document = UserLotMarksListClearDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserLotMarksListCreateDocument = gql`
    mutation userLotMarksListCreate($input: UserLotMarksListCreateInput!) {
  userLotMarksListCreate(input: $input) {
    clientMutationId
    userLotMarksListId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserLotMarksListCreateGQL extends Apollo.Mutation<UserLotMarksListCreateMutation, UserLotMarksListCreateMutationVariables> {
    document = UserLotMarksListCreateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserLotMarksListDeleteDocument = gql`
    mutation userLotMarksListDelete($input: UserLotMarksListDeleteInput!) {
  userLotMarksListDelete(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserLotMarksListDeleteGQL extends Apollo.Mutation<UserLotMarksListDeleteMutation, UserLotMarksListDeleteMutationVariables> {
    document = UserLotMarksListDeleteDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserLotMarksListUpdateDocument = gql`
    mutation userLotMarksListUpdate($input: UserLotMarksListUpdateInput!) {
  userLotMarksListUpdate(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserLotMarksListUpdateGQL extends Apollo.Mutation<UserLotMarksListUpdateMutation, UserLotMarksListUpdateMutationVariables> {
    document = UserLotMarksListUpdateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserLotMarksUpdateDocument = gql`
    mutation userLotMarksUpdate($input: UserLotMarksUpdateInput!) {
  userLotMarksUpdate(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserLotMarksUpdateGQL extends Apollo.Mutation<UserLotMarksUpdateMutation, UserLotMarksUpdateMutationVariables> {
    document = UserLotMarksUpdateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserUpdateDocument = gql`
    mutation userUpdate($input: UserUpdateInput!) {
  userUpdate(input: $input) {
    clientMutationId
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserUpdateGQL extends Apollo.Mutation<UserUpdateMutation, UserUpdateMutationVariables> {
    document = UserUpdateDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserViewBestBidSubscribeDocument = gql`
    mutation userViewBestBidSubscribe($input: UserViewBestBidSubscribeInput!) {
  userViewBestBidSubscribe(input: $input) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserViewBestBidSubscribeGQL extends Apollo.Mutation<UserViewBestBidSubscribeMutation, UserViewBestBidSubscribeMutationVariables> {
    document = UserViewBestBidSubscribeDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AlertsDocument = gql`
    query alerts($auctionId: ID, $target: AlertTargetEnum, $lotCode: Int, $isSanctioned: Boolean, $countryIso: String, $catalogCompanyTitle: String, $catalogModelTitle: String, $catalogFrameCode: String) {
  globalAlerts: alerts(auctionId: $auctionId, target: $target, lotCode: $lotCode, isSanctioned: $isSanctioned, countryIso: null, catalogCompanyTitle: $catalogCompanyTitle, catalogModelTitle: $catalogModelTitle, catalogFrameCode: $catalogFrameCode) {
    ...Alert
  }
  countryAlerts: alerts(auctionId: $auctionId, target: $target, lotCode: $lotCode, isSanctioned: $isSanctioned, countryIso: $countryIso, catalogCompanyTitle: $catalogCompanyTitle, catalogModelTitle: $catalogModelTitle, catalogFrameCode: $catalogFrameCode) {
    ...Alert
  }
}
    ${AlertFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AlertsGQL extends Apollo.Query<AlertsQuery, AlertsQueryVariables> {
    document = AlertsDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ApplicationSettingsDocument = gql`
    query applicationSettings {
  applicationSettings {
    aiTranslationGenerationEnabled
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ApplicationSettingsGQL extends Apollo.Query<ApplicationSettingsQuery, ApplicationSettingsQueryVariables> {
    document = ApplicationSettingsDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AuctionAliasesDocument = gql`
    query auctionAliases {
  auctions {
    id
    title
    cartrackAuctionId
    auctionAliases {
      id
      title
    }
    auctionSheetZones {
      ...AuctionSheetZone
    }
    auctionDescription {
      aiTranslationEnabled
      id
    }
    currentTradingTimeShifts {
      ...CurrentTradingTimeShift
    }
  }
}
    ${AuctionSheetZoneFragmentDoc}
${CurrentTradingTimeShiftFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AuctionAliasesGQL extends Apollo.Query<AuctionAliasesQuery, AuctionAliasesQueryVariables> {
    document = AuctionAliasesDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BidAmountRecommendationDocument = gql`
    query bidAmountRecommendation($companyEn: String!, $modelEn: String!, $modelTypeEn: String!, $year: Int!, $ratingEn: String!, $mileage: Int!, $noOfDays: Int) {
  weightedHarmonicMean(companyEn: $companyEn, modelEn: $modelEn, modelTypeEn: $modelTypeEn, year: $year, ratingEn: $ratingEn, mileage: $mileage, noOfDays: $noOfDays)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BidAmountRecommendationGQL extends Apollo.Query<BidAmountRecommendationQuery, BidAmountRecommendationQueryVariables> {
    document = BidAmountRecommendationDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BidAmountScoreDocument = gql`
    query bidAmountScore($amount: Int!, $companyEn: String!, $modelEn: String!, $modelTypeEn: String!, $year: Int!, $ratingEn: String!, $mileage: Int!) {
  bidScore(amount: $amount, companyEn: $companyEn, modelEn: $modelEn, modelTypeEn: $modelTypeEn, year: $year, ratingEn: $ratingEn, mileage: $mileage)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BidAmountScoreGQL extends Apollo.Query<BidAmountScoreQuery, BidAmountScoreQueryVariables> {
    document = BidAmountScoreDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BidDataDocument = gql`
    query bidData($date: DateTime!, $lotType: LotTypeEnum!, $auctionId: ID) {
  currentUser {
    id
    birthdate
    countryIso
    isOtherCountries
    maxBidAmountLimit
    ignoreSmallBidWarning
    bidTranslationByDefault
    defaultBidConditionId
    isManager: hasPermission(code: "world.akebono.auto.auctioneer")
    bidGroups(filter: {date: {eq: $date}}) {
      nodes {
        id
        letter
        quantity
        date
        bidsLimitReached
        lotsLimitReached
      }
      total
    }
    officeBranch {
      id
      code
      title
      isWorldwide
    }
  }
  bidConditions {
    id
    title
    isAuto
    isMoto
    isOnePrice
    isDisassembly
    minYear
  }
  maxBidAmount(lotType: $lotType)
  minBidCommission(lotType: $lotType)
  alerts(target: bidding, auctionId: $auctionId, isSanctioned: false) {
    ...Alert
  }
  sanctionedAlerts: alerts(target: bidding, auctionId: $auctionId, isSanctioned: true) {
    ...Alert
  }
}
    ${AlertFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BidDataGQL extends Apollo.Query<BidDataQuery, BidDataQueryVariables> {
    document = BidDataDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BidManualDataDocument = gql`
    query bidManualData($withUnassignedCartrackAuction: Boolean) {
  currentUser {
    id
    isOtherCountries
    isManager: hasPermission(code: "world.akebono.auto.auctioneer")
    officeBranch {
      id
      code
      title
      isWorldwide
    }
  }
  bidConditions {
    id
    title
    isAuto
    isMoto
    isOnePrice
    isDisassembly
    minYear
  }
  auctions(withUnassignedCartrackAuction: $withUnassignedCartrackAuction) {
    id
    title
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BidManualDataGQL extends Apollo.Query<BidManualDataQuery, BidManualDataQueryVariables> {
    document = BidManualDataDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BidsDocument = gql`
    query bids($first: Int, $offset: Int, $filter: AutoCurrentUserBidsFilter, $sort: AutoCurrentUserBidsSort, $bidLotAuctionDateFrom: DateTime, $bidLotAuctionDateTo: DateTime) {
  currentUser {
    id
    officeBranch {
      id
      code
      title
      isWorldwide
    }
    bids(first: $first, offset: $offset, filter: $filter, sort: $sort) {
      nodes {
        ...BidAmount
        nowBest
        wasOverbid
        needPriorityPass
        isGreenCorner
        createTranslation
        isParticipationAccepted
        ...BidComments
        bidCondition {
          id
          isAuto
          isMoto
          isOnePrice
          minYear
          title
        }
        bidGroup {
          date
          id
          letter
          quantity
          bidsLimitReached
          lotsLimitReached
        }
        createdAt
        id
        lot {
          createdAt
          id
          title
          code
          year
          images
          link
          auctionDate
          auctionDatetime
          auctionName
          companyEn
          modelEn
          modelGradeEn
          modelTypeEn
          colorEn
          mileageNum
          year
          status
          negotiationsPrice
          negotiationsAvailable
          negotiationsEndsAt
          tradingClosed
          tradingClosureBiddingEndsAt
          ratingEn
          modelYearEn
          modelDetailsEn
          engineVolumeNum
          equipmentEn
          transmissionEn
          auctionSystem
          startPriceNum
          endPriceNum
          thumbnails
          updatedAt
          soldPrice
          translations {
            file {
              filename
              fullPath
              id
              key
            }
            id
            language
            message
          }
        }
        status
        updatedAt
      }
      total
    }
    initialBidsCount: bids(filter: {bidLotAuctionDate: {gte: $bidLotAuctionDateFrom, lte: $bidLotAuctionDateTo}, bidStatus: {eq: initial}}) {
      total
    }
    translatedBidsCount: bids(filter: {bidLotAuctionDate: {gte: $bidLotAuctionDateFrom, lte: $bidLotAuctionDateTo}, bidStatus: {eq: initial}, bidLotTranslationsCount: {gte: 1}, bidCreateTranslation: {eq: true}, bidIsParticipationAccepted: {eq: null}}) {
      total
    }
    confirmedBidsCount: bids(filter: {bidLotAuctionDate: {gte: $bidLotAuctionDateFrom, lte: $bidLotAuctionDateTo}, bidStatus: {eq: confirmed}}) {
      total
    }
    wonBidsCount: bids(filter: {bidLotAuctionDate: {gte: $bidLotAuctionDateFrom, lte: $bidLotAuctionDateTo}, bidStatus: {eq: won}}) {
      total
    }
    canceledBidsCount: bids(filter: {bidLotAuctionDate: {gte: $bidLotAuctionDateFrom, lte: $bidLotAuctionDateTo}, bidStatus: {eq: canceled}}) {
      total
    }
    allBidsCount: bids(filter: {bidLotAuctionDate: {gte: $bidLotAuctionDateFrom, lte: $bidLotAuctionDateTo}, bidStatus: {eq: null}}) {
      total
    }
  }
  bidConditions {
    id
    title
    isAuto
    isMoto
    isOnePrice
    isDisassembly
    minYear
  }
}
    ${BidAmountFragmentDoc}
${BidCommentsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BidsGQL extends Apollo.Query<BidsQuery, BidsQueryVariables> {
    document = BidsDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BidConditionsDocument = gql`
    query bidConditions {
  bidConditions {
    id
    title
    isAuto
    isMoto
    isOnePrice
    minYear
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BidConditionsGQL extends Apollo.Query<BidConditionsQuery, BidConditionsQueryVariables> {
    document = BidConditionsDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BoundaryLotsDocument = gql`
    query boundaryLots($first: Int, $offset: Int, $filter: BoundaryLotsFilter) {
  boundaryLots(first: $first, offset: $offset, filter: $filter) {
    nodes {
      ...UniversalLotTable
    }
    total
  }
  boundaryLotsCount: boundaryLots {
    total
  }
}
    ${UniversalLotTableFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BoundaryLotsGQL extends Apollo.Query<BoundaryLotsQuery, BoundaryLotsQueryVariables> {
    document = BoundaryLotsDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentLotMarksListsDocument = gql`
    query currentLotMarksLists {
  currentUser {
    lotMarksLists {
      id
      path
      title
      images
      createdAt
      publishedAt
      description
      lotMarks {
        ...UserLotMark
      }
    }
  }
}
    ${UserLotMarkFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentLotMarksListsGQL extends Apollo.Query<CurrentLotMarksListsQuery, CurrentLotMarksListsQueryVariables> {
    document = CurrentLotMarksListsDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentLotMarksDocument = gql`
    query currentLotMarks($first: Int, $offset: Int, $filter: AutoCurrentUserLotMarksFilter) {
  currentUser {
    lotMarks(first: $first, offset: $offset, filter: $filter) {
      nodes {
        id
        lot {
          id
        }
        mark
        viewsCount
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentLotMarksGQL extends Apollo.Query<CurrentLotMarksQuery, CurrentLotMarksQueryVariables> {
    document = CurrentLotMarksDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentUserMinimalDocument = gql`
    query currentUserMinimal {
  currentUser {
    id
    username
    fullName
    limitLotsDaily
    limitLotBids
    officeBranch {
      id
      code
      title
      isWorldwide
    }
    preferredLang
    countryIso
    defaultTranslationMediaType
    plan {
      id
      title
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentUserMinimalGQL extends Apollo.Query<CurrentUserMinimalQuery, CurrentUserMinimalQueryVariables> {
    document = CurrentUserMinimalDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const HasActiveGuidanceRequestDocument = gql`
    query hasActiveGuidanceRequest {
  currentUser {
    id
    hasActiveGuidanceRequest
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class HasActiveGuidanceRequestGQL extends Apollo.Query<HasActiveGuidanceRequestQuery, HasActiveGuidanceRequestQueryVariables> {
    document = HasActiveGuidanceRequestDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImportedBidsBiddingDataDocument = gql`
    query importedBidsBiddingData($todayDate: DateTime!) {
  currentUser {
    id
    countryIso
    isOtherCountries
    maxBidAmountLimit
    isManager: hasPermission(code: "world.akebono.auto.auctioneer")
    isTranslator: hasPermission(code: "world.akebono.auto.translator")
    isAuctioneer: hasPermission(code: "world.akebono.auto.auctioneer")
    bidGroups(filter: {date: {gte: $todayDate}}) {
      nodes {
        id
        date
        letter
        quantity
        bidsLimitReached
        lotsLimitReached
      }
      total
    }
    officeBranch {
      id
      code
      title
      isWorldwide
    }
  }
  bidConditions {
    id
    title
    isAuto
    isMoto
    isOnePrice
    isDisassembly
    minYear
  }
  autoMaxBidAmount: maxBidAmount(lotType: auto)
  motoMaxBidAmount: maxBidAmount(lotType: moto)
  onepriceMaxBidAmount: maxBidAmount(lotType: oneprice)
  autoMinBidCommission: minBidCommission(lotType: auto)
  motoMinBidCommission: minBidCommission(lotType: moto)
  onepriceMinBidCommission: minBidCommission(lotType: oneprice)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportedBidsBiddingDataGQL extends Apollo.Query<ImportedBidsBiddingDataQuery, ImportedBidsBiddingDataQueryVariables> {
    document = ImportedBidsBiddingDataDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImportedLotsDocument = gql`
    query importedLots($lotFilters: [CodeDateAuctionNameInput!]!) {
  lotsByKeys(lotKeys: $lotFilters) {
    ...ImportedLot
  }
}
    ${ImportedLotFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportedLotsGQL extends Apollo.Query<ImportedLotsQuery, ImportedLotsQueryVariables> {
    document = ImportedLotsDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotsCountersDocument = gql`
    query lotsCounters($lotIds: [String!]!, $subgroup: LotTypeEnum!, $lotSource: LotSource!) {
  lots(filter: {lotOriginalIds: {eq: $lotIds}, lotType: {eq: $subgroup}, lotSource: {eq: $lotSource}}) {
    nodes {
      ...LotCounters
    }
    total
  }
  lotsViewsCounts(lotType: $subgroup, lotSource: $lotSource, lotIds: $lotIds) {
    ...LotViewsCount
  }
}
    ${LotCountersFragmentDoc}
${LotViewsCountFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LotsCountersGQL extends Apollo.Query<LotsCountersQuery, LotsCountersQueryVariables> {
    document = LotsCountersDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotListDataDocument = gql`
    query lotListData($lotIds: [String!]!, $subgroup: LotTypeEnum!, $lotSource: LotSource!) {
  lots(filter: {lotOriginalIds: {eq: $lotIds}, lotType: {eq: $subgroup}, lotSource: {eq: $lotSource}}) {
    nodes {
      ...LotData
    }
    total
  }
}
    ${LotDataFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LotListDataGQL extends Apollo.Query<LotListDataQuery, LotListDataQueryVariables> {
    document = LotListDataDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotDocument = gql`
    query lot($id: LotID!, $subgroup: LotTypeEnum!, $lotSource: LotSource!, $siteDomain: String) {
  lotViewsCount(lotType: $subgroup, lotSource: $lotSource, lotId: $id) {
    ...LotViewsCount
  }
  lot(id: $id, subgroup: $subgroup, lotSource: $lotSource, siteDomain: $siteDomain) {
    createdAt
    id
    title
    code
    year
    images
    description
    auctionDate
    auctionDatetime
    auctionName
    companyEn
    modelEn
    modelGradeEn
    modelTypeEn
    colorEn
    mileageNum
    year
    ratingEn
    modelYearEn
    modelDetailsEn
    equipmentEn
    transmissionEn
    auctionSystem
    startPriceNum
    endPriceNum
    engineVolumeNum
    thumbnails
    updatedAt
    soldPrice
    subgroup
    ...LotCounters
    translations {
      file {
        filename
        fullPath
        id
        key
      }
      id
      language
      message
    }
  }
}
    ${LotViewsCountFragmentDoc}
${LotCountersFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LotGQL extends Apollo.Query<LotQuery, LotQueryVariables> {
    document = LotDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotsInspectedDocument = gql`
    query lotsInspected($lots: [LotInspectionInput!]!) {
  lotsInspected(lots: $lots) {
    id
    subgroup
    source
    inspected
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LotsInspectedGQL extends Apollo.Query<LotsInspectedQuery, LotsInspectedQueryVariables> {
    document = LotsInspectedDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LotsDocument = gql`
    query lots($first: Int, $offset: Int, $filter: LotsFilter, $sort: LotsSort) {
  lots(first: $first, offset: $offset, filter: $filter, sort: $sort) {
    nodes {
      ...LotCounters
      createdAt
      id
      title
      code
      year
      images
      auctionDate
      auctionDatetime
      auctionName
      companyEn
      modelEn
      modelGradeEn
      modelTypeEn
      colorEn
      mileageNum
      year
      ratingEn
      modelYearEn
      modelDetailsEn
      equipmentEn
      transmissionEn
      auctionSystem
      startPriceNum
      endPriceNum
      engineVolumeNum
      thumbnails
      updatedAt
      soldPrice
      subgroup
      currentUserLotMarks {
        ...UserLotMark
      }
      translations {
        file {
          filename
          fullPath
          id
          key
        }
        id
        language
        message
      }
    }
    total
  }
}
    ${LotCountersFragmentDoc}
${UserLotMarkFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LotsGQL extends Apollo.Query<LotsQuery, LotsQueryVariables> {
    document = LotsDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkedLotsDocument = gql`
    query markedLots($first: Int, $offset: Int, $filter: AutoCurrentUserLotMarksFilter, $sort: AutoCurrentUserLotMarksSort) {
  currentUser {
    id
    lotMarks(first: $first, offset: $offset, filter: $filter, sort: $sort) {
      nodes {
        id
        lot {
          ...UniversalLotTable
        }
      }
      total
    }
    lotMarksLists {
      id
      path
      title
      publishedAt
    }
    userChannel {
      id
      path
      title
      userId
      images
      updatedAt
      createdAt
      publishedAt
      description
    }
  }
}
    ${UniversalLotTableFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkedLotsGQL extends Apollo.Query<MarkedLotsQuery, MarkedLotsQueryVariables> {
    document = MarkedLotsDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NegotiationLotsCountDocument = gql`
    query negotiationLotsCount {
  negotiationLotsCount
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NegotiationLotsCountGQL extends Apollo.Query<NegotiationLotsCountQuery, NegotiationLotsCountQueryVariables> {
    document = NegotiationLotsCountDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SanctionsServiceDataDocument = gql`
    query sanctionsServiceData {
  currentUser {
    id
    isTranslator: hasPermission(code: "world.akebono.auto.translator")
    isAuctioneer: hasPermission(code: "world.akebono.auto.auctioneer")
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SanctionsServiceDataGQL extends Apollo.Query<SanctionsServiceDataQuery, SanctionsServiceDataQueryVariables> {
    document = SanctionsServiceDataDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserCountryIsoDocument = gql`
    query userCountryIso {
  currentUser {
    id
    countryIso
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserCountryIsoGQL extends Apollo.Query<UserCountryIsoQuery, UserCountryIsoQueryVariables> {
    document = UserCountryIsoDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserFilterPresetsDocument = gql`
    query userFilterPresets {
  currentUser {
    id
    userFilterPresets {
      id
      title
      content
      compilationEmailEnabled
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserFilterPresetsGQL extends Apollo.Query<UserFilterPresetsQuery, UserFilterPresetsQueryVariables> {
    document = UserFilterPresetsDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserLimitsDataDocument = gql`
    query userLimitsData($auctionDate: DateTime!) {
  currentUser {
    id
    lotsLimitReached(auctionDate: $auctionDate)
    lotProductionDateCheckRequestsLimitReached(auctionDate: $auctionDate)
    permissions {
      id
      code
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserLimitsDataGQL extends Apollo.Query<UserLimitsDataQuery, UserLimitsDataQueryVariables> {
    document = UserLimitsDataDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserLotMarkDocument = gql`
    query userLotMark($id: LotID!, $subgroup: LotTypeEnum!, $lotSource: LotSource!) {
  lot(id: $id, subgroup: $subgroup, lotSource: $lotSource) {
    currentUserLotMarks {
      ...UserLotMarkData
      viewsCount
      userLotMarksListTitle
    }
  }
}
    ${UserLotMarkDataFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserLotMarkGQL extends Apollo.Query<UserLotMarkQuery, UserLotMarkQueryVariables> {
    document = UserLotMarkDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserLotMarksDocument = gql`
    query userLotMarks($first: Int, $offset: Int, $filter: AutoCurrentUserLotMarksFilter) {
  currentUser {
    id
    lotMarks(first: $first, offset: $offset, filter: $filter) {
      nodes {
        ...UserLotMarkData
      }
      total
    }
  }
}
    ${UserLotMarkDataFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserLotMarksGQL extends Apollo.Query<UserLotMarksQuery, UserLotMarksQueryVariables> {
    document = UserLotMarksDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserLotDocument = gql`
    query userLot($id: LotID!, $subgroup: LotTypeEnum!, $lotSource: LotSource!, $siteDomain: String) {
  lotViewsCount(lotType: $subgroup, lotSource: $lotSource, lotId: $id) {
    ...LotViewsCount
  }
  currentUser {
    id
    isOtherCountries
    hideBidAmount
    preferredLang
    countryIso
    defaultTranslationMediaType
    ...UserViewBestBidSubscriptionData
    canSeeBestBid: hasPermission(code: "cars.best-bid")
    canSeeBestBidAdmin: hasPermission(code: "cars.best-bid-admin")
    isTranslator: hasPermission(code: "world.akebono.auto.translator")
    isAuctioneer: hasPermission(code: "world.akebono.auto.auctioneer")
    isEmployee: hasPermission(code: "world.akebono.auto.employee")
    hasClearPhotos: hasPermission(code: "cars.clear-uss-photos")
    canCheckProductionDate: hasPermission(code: "cars.production-date-check")
    canRecheckProductionDate: hasPermission(code: "cars.production-date-recheck")
    canEditStartPrice: hasPermission(code: "cars.edit-start-price")
    canEditEngineVolume: hasPermission(code: "cars.edit-engine-volume")
    canSeeUsersBids: hasPermission(code: "cars.lot-user-bids")
    canUpdateLotInfo: hasPermission(code: "cars.lot-details-update")
    canDownloadUssPhotos: hasPermission(code: "cars.uss-photos-download")
  }
  auctions {
    id
    title
    cartrackAuctionId
    auctionAliases {
      id
      title
    }
  }
  lot(id: $id, lotSource: $lotSource, subgroup: $subgroup, siteDomain: $siteDomain) {
    ...LotCounters
    createdAt
    canRecognizeAuctionList
    currentUserLotMarks {
      ...UserLotMarkData
      viewsCount
      userLotMarksListTitle
    }
    id
    vin
    images
    thumbnails
    code
    description
    auctionDate
    auctionDatetime
    auctionName
    companyEn
    modelEn
    modelGradeEn
    modelTypeEn
    colorEn
    mileageNum
    year
    status
    ratingEn
    modelYearEn
    modelDetailsEn
    equipmentEn
    transmissionEn
    auctionSystem
    startPriceNum
    engineVolumeNum
    endPriceNum
    soldPrice
    latestBid
    icons
    jupiterLotData
    kawasakiLotData
    canToggleTranslationsHidden
    expectedTranslationInSeconds
    translations {
      ...LotTranslation
    }
    lotSetting {
      translationsHidden
    }
    isRestricted
    negotiationsPrice
    canOpenNegotiations
    canEditNegotiationsPrice
    negotiationsAvailable
    negotiationsEndsAt
    tradingClosed
    tradingClosureBiddingEndsAt
    updatedAt
    productionDate
    productionDatePayload
    currentUserLotBidsLimitReached
    currentUserLimitsOverrideAvailable
    currentUserLastBid {
      id
      status
      wasOverbid
      isNegotiationsAccepted
      isParticipationAccepted
      translationComplete
      createTranslation
      nowBest
      needPriorityPass
      isGreenCorner
      createdAt
      user {
        id
      }
      bidGroup {
        id
        date
        letter
        quantity
      }
      ...BidAmount
    }
    currentUserLotNote {
      createdAt
      id
      lotId
      note
      updatedAt
      userId
    }
    hasBestBid
    bestBid {
      id
      ...BidAmount
      isByCurrentUser
      user {
        id
        fullName
      }
    }
    bidsCount
    bids {
      id
      ...BidAmount
      status
      isGreenCorner
      createTranslation
      notify
      createdAt
      needPriorityPass
      bidCondition {
        id
        title
      }
      bidGroup {
        id
        letter
        quantity
      }
      user {
        id
        fullName
        hasActiveBestBidViewServiceSubscription
      }
    }
    ...LotVersions
    ...LotViews
  }
}
    ${LotViewsCountFragmentDoc}
${UserViewBestBidSubscriptionDataFragmentDoc}
${LotCountersFragmentDoc}
${UserLotMarkDataFragmentDoc}
${LotTranslationFragmentDoc}
${BidAmountFragmentDoc}
${LotVersionsFragmentDoc}
${LotViewsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserLotGQL extends Apollo.Query<UserLotQuery, UserLotQueryVariables> {
    document = UserLotDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserPurchaseStatisticsDocument = gql`
    query userPurchaseStatistics($todayDate: DateTime!, $yesterdayDate: DateTime!, $weekStartDate: DateTime!) {
  currentUser {
    id
    todayPurchases: bids(filter: {bidStatus: {eq: won}, bidLotAuctionDate: {eq: $todayDate}}) {
      total
    }
    yesterdayPurchases: bids(filter: {bidStatus: {eq: won}, bidLotAuctionDate: {eq: $yesterdayDate}}) {
      total
    }
    weekPurchases: bids(filter: {bidStatus: {eq: won}, bidLotAuctionDate: {gt: $weekStartDate}}) {
      total
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserPurchaseStatisticsGQL extends Apollo.Query<UserPurchaseStatisticsQuery, UserPurchaseStatisticsQueryVariables> {
    document = UserPurchaseStatisticsDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserSettingsDocument = gql`
    query userSettings {
  currentUser {
    id
    ...UserBidSettings
    ...UserTranslationSettings
    ...UserNotificationSettings
  }
}
    ${UserBidSettingsFragmentDoc}
${UserTranslationSettingsFragmentDoc}
${UserNotificationSettingsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserSettingsGQL extends Apollo.Query<UserSettingsQuery, UserSettingsQueryVariables> {
    document = UserSettingsDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserViewBestBidSubscribeDataDocument = gql`
    query userViewBestBidSubscribeData {
  currentUser {
    id
    isTrusted
    isEnoughFundsToSubscribeToViewTheBestBid
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserViewBestBidSubscribeDataGQL extends Apollo.Query<UserViewBestBidSubscribeDataQuery, UserViewBestBidSubscribeDataQueryVariables> {
    document = UserViewBestBidSubscribeDataDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const VinCheckerInfoDocument = gql`
    query vinCheckerInfo {
  vincheckerInfo {
    chassisId
    maker
    necessaryDigitInBodyNumber
    rangeEndDate
    rangeStartDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class VinCheckerInfoGQL extends Apollo.Query<VinCheckerInfoQuery, VinCheckerInfoQueryVariables> {
    document = VinCheckerInfoDocument;
    client = 'auto-main';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "UserRequestUnion": [
      "BidDeleteRequest",
      "LotProductionDateCheckRequest",
      "LotTranslateRequest"
    ],
    "UserRequestInterface": [
      "BidDeleteRequest",
      "LotProductionDateCheckRequest",
      "LotTranslateRequest"
    ]
  }
};
      export default result;
    